/* tslint:disable */
/* eslint-disable */
/**
 * DIGITANE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * New WordPress user password
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'newWpUserPass': string;
    /**
     * 
     * @type {SiteType}
     * @memberof ChangePasswordRequest
     */
    'siteName': SiteType;
    /**
     * WordPress user email
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'wpUserEmail': string;
    /**
     * WordPress user ID
     * @type {number}
     * @memberof ChangePasswordRequest
     */
    'wpUserId': number;
    /**
     * Current WordPress user password
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'wpUserPass': string;
}


/**
 * 
 * @export
 * @interface ChangePasswordResponse
 */
export interface ChangePasswordResponse {
    /**
     * 
     * @type {ChangePasswordUser}
     * @memberof ChangePasswordResponse
     */
    'data'?: ChangePasswordUser;
    /**
     * Response message
     * @type {string}
     * @memberof ChangePasswordResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof ChangePasswordResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ChangePasswordUser
 */
export interface ChangePasswordUser {
    /**
     * Changed user ID
     * @type {number}
     * @memberof ChangePasswordUser
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface Chapter
 */
export interface Chapter {
    /**
     * 
     * @type {any}
     * @memberof Chapter
     */
    'currentChapterResult'?: any | null;
    /**
     * Associated exp ID
     * @type {number}
     * @memberof Chapter
     */
    'expId'?: number | null;
    /**
     * Chapter hint
     * @type {string}
     * @memberof Chapter
     */
    'hint'?: string;
    /**
     * Chapter ID
     * @type {number}
     * @memberof Chapter
     */
    'id': number;
    /**
     * Is this chapter a challenge
     * @type {boolean}
     * @memberof Chapter
     */
    'isChallenge': boolean;
    /**
     * Associated mission ID
     * @type {number}
     * @memberof Chapter
     */
    'missionId': number;
    /**
     * Chapter name
     * @type {string}
     * @memberof Chapter
     */
    'name': string;
    /**
     * Sequence order of the chapter
     * @type {number}
     * @memberof Chapter
     */
    'seq': number;
    /**
     * Associated video code
     * @type {string}
     * @memberof Chapter
     */
    'videoCode': string;
}
/**
 * 
 * @export
 * @interface ChapterList
 */
export interface ChapterList {
    /**
     * List of chapter
     * @type {Array<Chapter>}
     * @memberof ChapterList
     */
    'chapters'?: Array<Chapter>;
}
/**
 * 
 * @export
 * @interface ChapterListResponse
 */
export interface ChapterListResponse {
    /**
     * 
     * @type {ChapterListResponseData}
     * @memberof ChapterListResponse
     */
    'data'?: ChapterListResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof ChapterListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof ChapterListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ChapterListResponseData
 */
export interface ChapterListResponseData {
    /**
     * List of chapter
     * @type {Array<Chapter>}
     * @memberof ChapterListResponseData
     */
    'chapters'?: Array<Chapter>;
}
/**
 * 
 * @export
 * @interface ChapterResponse
 */
export interface ChapterResponse {
    /**
     * 
     * @type {ChapterResponseData}
     * @memberof ChapterResponse
     */
    'data'?: ChapterResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof ChapterResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof ChapterResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ChapterResponseData
 */
export interface ChapterResponseData {
    /**
     * 
     * @type {any}
     * @memberof ChapterResponseData
     */
    'currentChapterResult'?: any | null;
    /**
     * Associated exp ID
     * @type {number}
     * @memberof ChapterResponseData
     */
    'expId'?: number | null;
    /**
     * Chapter hint
     * @type {string}
     * @memberof ChapterResponseData
     */
    'hint'?: string;
    /**
     * Chapter ID
     * @type {number}
     * @memberof ChapterResponseData
     */
    'id': number;
    /**
     * Is this chapter a challenge
     * @type {boolean}
     * @memberof ChapterResponseData
     */
    'isChallenge': boolean;
    /**
     * Associated mission ID
     * @type {number}
     * @memberof ChapterResponseData
     */
    'missionId': number;
    /**
     * Chapter name
     * @type {string}
     * @memberof ChapterResponseData
     */
    'name': string;
    /**
     * Sequence order of the chapter
     * @type {number}
     * @memberof ChapterResponseData
     */
    'seq': number;
    /**
     * Associated video code
     * @type {string}
     * @memberof ChapterResponseData
     */
    'videoCode': string;
}
/**
 * 
 * @export
 * @interface ChapterRewardsData
 */
export interface ChapterRewardsData {
    /**
     * 
     * @type {string}
     * @memberof ChapterRewardsData
     */
    'chapterId': string;
    /**
     * 
     * @type {number}
     * @memberof ChapterRewardsData
     */
    'exp'?: number;
}
/**
 * 
 * @export
 * @interface CommunityCharacterData
 */
export interface CommunityCharacterData {
    /**
     * 
     * @type {string}
     * @memberof CommunityCharacterData
     */
    'avatarUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityCharacterData
     */
    'characterType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityCharacterData
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityCharacterData
     */
    'displayName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommunityCharacterData
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityCharacterData
     */
    'userId'?: number;
}
/**
 * 
 * @export
 * @interface CommunityCharacterListResponse
 */
export interface CommunityCharacterListResponse {
    /**
     * 
     * @type {Array<CommunityCharacterData>}
     * @memberof CommunityCharacterListResponse
     */
    'data'?: Array<CommunityCharacterData>;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityCharacterListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityCharacterListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityCharacterMeData
 */
export interface CommunityCharacterMeData {
    /**
     * 
     * @type {CommunityCharacterMeDataCharacter}
     * @memberof CommunityCharacterMeData
     */
    'character'?: CommunityCharacterMeDataCharacter;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityCharacterMeData
     */
    'isCharacter'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityCharacterMeDataCharacter
 */
export interface CommunityCharacterMeDataCharacter {
    /**
     * 
     * @type {string}
     * @memberof CommunityCharacterMeDataCharacter
     */
    'avatarUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityCharacterMeDataCharacter
     */
    'characterType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityCharacterMeDataCharacter
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityCharacterMeDataCharacter
     */
    'displayName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommunityCharacterMeDataCharacter
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityCharacterMeDataCharacter
     */
    'userId'?: number;
}
/**
 * 
 * @export
 * @interface CommunityCharacterMeResponse
 */
export interface CommunityCharacterMeResponse {
    /**
     * 
     * @type {CommunityCharacterMeResponseData}
     * @memberof CommunityCharacterMeResponse
     */
    'data'?: CommunityCharacterMeResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityCharacterMeResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityCharacterMeResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityCharacterMeResponseData
 */
export interface CommunityCharacterMeResponseData {
    /**
     * 
     * @type {CommunityCharacterMeDataCharacter}
     * @memberof CommunityCharacterMeResponseData
     */
    'character'?: CommunityCharacterMeDataCharacter;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityCharacterMeResponseData
     */
    'isCharacter'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityComment
 */
export interface CommunityComment {
    /**
     * 
     * @type {string}
     * @memberof CommunityComment
     */
    'authorIcon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityComment
     */
    'authorName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityComment
     */
    'avatarUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityComment
     */
    'body'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityComment
     */
    'characterType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityComment
     */
    'createdAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommunityComment
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityComment
     */
    'projectId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityComment
     */
    'userId'?: number;
}
/**
 * 
 * @export
 * @interface CommunityCommentCreateRequest
 */
export interface CommunityCommentCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityCommentCreateRequest
     */
    'body': string;
}
/**
 * 
 * @export
 * @interface CommunityCommentCreateResponse
 */
export interface CommunityCommentCreateResponse {
    /**
     * 
     * @type {CommunityCommentCreateResponseData}
     * @memberof CommunityCommentCreateResponse
     */
    'data'?: CommunityCommentCreateResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityCommentCreateResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityCommentCreateResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityCommentCreateResponseData
 */
export interface CommunityCommentCreateResponseData {
    /**
     * 
     * @type {number}
     * @memberof CommunityCommentCreateResponseData
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CommunityCommentDeleteResponse
 */
export interface CommunityCommentDeleteResponse {
    /**
     * 
     * @type {CommunityCommentCreateResponseData}
     * @memberof CommunityCommentDeleteResponse
     */
    'data'?: CommunityCommentCreateResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityCommentDeleteResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityCommentDeleteResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityCommentDetail
 */
export interface CommunityCommentDetail {
    /**
     * 
     * @type {number}
     * @memberof CommunityCommentDetail
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CommunityCommentListData
 */
export interface CommunityCommentListData {
    /**
     * 
     * @type {Array<CommunityComment>}
     * @memberof CommunityCommentListData
     */
    'comments'?: Array<CommunityComment>;
    /**
     * 
     * @type {number}
     * @memberof CommunityCommentListData
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityCommentListData
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityCommentListData
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface CommunityCommentListResponse
 */
export interface CommunityCommentListResponse {
    /**
     * 
     * @type {CommunityCommentListResponseData}
     * @memberof CommunityCommentListResponse
     */
    'data'?: CommunityCommentListResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityCommentListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityCommentListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityCommentListResponseData
 */
export interface CommunityCommentListResponseData {
    /**
     * 
     * @type {Array<CommunityComment>}
     * @memberof CommunityCommentListResponseData
     */
    'comments'?: Array<CommunityComment>;
    /**
     * 
     * @type {number}
     * @memberof CommunityCommentListResponseData
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityCommentListResponseData
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityCommentListResponseData
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface CommunityEventData
 */
export interface CommunityEventData {
    /**
     * 
     * @type {string}
     * @memberof CommunityEventData
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommunityEventData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityEventData
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CommunityEventListResponse
 */
export interface CommunityEventListResponse {
    /**
     * 
     * @type {Array<CommunityEventData>}
     * @memberof CommunityEventListResponse
     */
    'data'?: Array<CommunityEventData>;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityEventListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityEventListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityProject
 */
export interface CommunityProject {
    /**
     * 
     * @type {string}
     * @memberof CommunityProject
     */
    'authorIcon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommunityProject
     */
    'authorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityProject
     */
    'authorName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommunityProject
     */
    'commentCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityProject
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityProject
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommunityProject
     */
    'eventId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProject
     */
    'grade'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommunityProject
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityProject
     */
    'lang'?: CommunityProjectLangEnum;
    /**
     * 
     * @type {number}
     * @memberof CommunityProject
     */
    'likeCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityProject
     */
    'likedByMe'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommunityProject
     */
    'playCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityProject
     */
    'playedByMe'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityProject
     */
    'schoolId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProject
     */
    'thumbnailUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProject
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityProject
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityProject
     */
    'url'?: string;
}

export const CommunityProjectLangEnum = {
    Scratch: 'scratch',
    Micratch: 'micratch',
    Micratch2: 'micratch2',
    Roblox: 'roblox',
    Javascript: 'javascript',
    HtmlCss: 'html_css',
    AppInventor: 'app_inventor'
} as const;

export type CommunityProjectLangEnum = typeof CommunityProjectLangEnum[keyof typeof CommunityProjectLangEnum];

/**
 * 
 * @export
 * @interface CommunityProjectCreateRequest
 */
export interface CommunityProjectCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectCreateRequest
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectCreateRequest
     */
    'eventId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectCreateRequest
     */
    'grade'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectCreateRequest
     */
    'lang': CommunityProjectCreateRequestLangEnum;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectCreateRequest
     */
    'schoolId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectCreateRequest
     */
    'thumbnailUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectCreateRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectCreateRequest
     */
    'url': string;
}

export const CommunityProjectCreateRequestLangEnum = {
    Scratch: 'scratch',
    Micratch: 'micratch',
    Micratch2: 'micratch2',
    Roblox: 'roblox',
    Javascript: 'javascript',
    HtmlCss: 'html_css',
    AppInventor: 'app_inventor'
} as const;

export type CommunityProjectCreateRequestLangEnum = typeof CommunityProjectCreateRequestLangEnum[keyof typeof CommunityProjectCreateRequestLangEnum];

/**
 * 
 * @export
 * @interface CommunityProjectCreateResponse
 */
export interface CommunityProjectCreateResponse {
    /**
     * 
     * @type {CommunityProjectCreateResponseData}
     * @memberof CommunityProjectCreateResponse
     */
    'data'?: CommunityProjectCreateResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityProjectCreateResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityProjectCreateResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityProjectCreateResponseData
 */
export interface CommunityProjectCreateResponseData {
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectCreateResponseData
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CommunityProjectDeleteResponse
 */
export interface CommunityProjectDeleteResponse {
    /**
     * 
     * @type {CommunityProjectCreateResponseData}
     * @memberof CommunityProjectDeleteResponse
     */
    'data'?: CommunityProjectCreateResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityProjectDeleteResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityProjectDeleteResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityProjectDetail
 */
export interface CommunityProjectDetail {
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectDetail
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CommunityProjectDetailResponse
 */
export interface CommunityProjectDetailResponse {
    /**
     * 
     * @type {CommunityProjectDetailResponseData}
     * @memberof CommunityProjectDetailResponse
     */
    'data'?: CommunityProjectDetailResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityProjectDetailResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityProjectDetailResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityProjectDetailResponseData
 */
export interface CommunityProjectDetailResponseData {
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectDetailResponseData
     */
    'authorIcon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectDetailResponseData
     */
    'authorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectDetailResponseData
     */
    'authorName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectDetailResponseData
     */
    'commentCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectDetailResponseData
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectDetailResponseData
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectDetailResponseData
     */
    'eventId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectDetailResponseData
     */
    'grade'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectDetailResponseData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectDetailResponseData
     */
    'lang'?: CommunityProjectDetailResponseDataLangEnum;
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectDetailResponseData
     */
    'likeCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityProjectDetailResponseData
     */
    'likedByMe'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectDetailResponseData
     */
    'playCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityProjectDetailResponseData
     */
    'playedByMe'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectDetailResponseData
     */
    'schoolId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectDetailResponseData
     */
    'thumbnailUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectDetailResponseData
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectDetailResponseData
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectDetailResponseData
     */
    'url'?: string;
}

export const CommunityProjectDetailResponseDataLangEnum = {
    Scratch: 'scratch',
    Micratch: 'micratch',
    Micratch2: 'micratch2',
    Roblox: 'roblox',
    Javascript: 'javascript',
    HtmlCss: 'html_css',
    AppInventor: 'app_inventor'
} as const;

export type CommunityProjectDetailResponseDataLangEnum = typeof CommunityProjectDetailResponseDataLangEnum[keyof typeof CommunityProjectDetailResponseDataLangEnum];

/**
 * 
 * @export
 * @interface CommunityProjectLikeData
 */
export interface CommunityProjectLikeData {
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectLikeData
     */
    'likeCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityProjectLikeData
     */
    'liked'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityProjectLikeResponse
 */
export interface CommunityProjectLikeResponse {
    /**
     * 
     * @type {CommunityProjectLikeResponseData}
     * @memberof CommunityProjectLikeResponse
     */
    'data'?: CommunityProjectLikeResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityProjectLikeResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityProjectLikeResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityProjectLikeResponseData
 */
export interface CommunityProjectLikeResponseData {
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectLikeResponseData
     */
    'likeCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityProjectLikeResponseData
     */
    'liked'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityProjectListData
 */
export interface CommunityProjectListData {
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectListData
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectListData
     */
    'offset'?: number;
    /**
     * 
     * @type {Array<CommunityProject>}
     * @memberof CommunityProjectListData
     */
    'projects'?: Array<CommunityProject>;
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectListData
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface CommunityProjectListResponse
 */
export interface CommunityProjectListResponse {
    /**
     * 
     * @type {CommunityProjectListResponseData}
     * @memberof CommunityProjectListResponse
     */
    'data'?: CommunityProjectListResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityProjectListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityProjectListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityProjectListResponseData
 */
export interface CommunityProjectListResponseData {
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectListResponseData
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectListResponseData
     */
    'offset'?: number;
    /**
     * 
     * @type {Array<CommunityProject>}
     * @memberof CommunityProjectListResponseData
     */
    'projects'?: Array<CommunityProject>;
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectListResponseData
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface CommunityProjectPlayData
 */
export interface CommunityProjectPlayData {
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectPlayData
     */
    'playCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityProjectPlayData
     */
    'played'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityProjectPlayResponse
 */
export interface CommunityProjectPlayResponse {
    /**
     * 
     * @type {CommunityProjectPlayResponseData}
     * @memberof CommunityProjectPlayResponse
     */
    'data'?: CommunityProjectPlayResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityProjectPlayResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityProjectPlayResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityProjectPlayResponseData
 */
export interface CommunityProjectPlayResponseData {
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectPlayResponseData
     */
    'playCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityProjectPlayResponseData
     */
    'played'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityProjectUpdateRequest
 */
export interface CommunityProjectUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectUpdateRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommunityProjectUpdateRequest
     */
    'eventId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectUpdateRequest
     */
    'grade'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectUpdateRequest
     */
    'schoolId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectUpdateRequest
     */
    'thumbnailUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectUpdateRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityProjectUpdateRequest
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface CommunityProjectUpdateResponse
 */
export interface CommunityProjectUpdateResponse {
    /**
     * 
     * @type {CommunityProjectCreateResponseData}
     * @memberof CommunityProjectUpdateResponse
     */
    'data'?: CommunityProjectCreateResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CommunityProjectUpdateResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CommunityProjectUpdateResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface Course
 */
export interface Course {
    /**
     * course code
     * @type {string}
     * @memberof Course
     */
    'code': string;
    /**
     * course description
     * @type {string}
     * @memberof Course
     */
    'description'?: string;
    /**
     * course name
     * @type {string}
     * @memberof Course
     */
    'name': string;
    /**
     * 
     * @type {SiteType}
     * @memberof Course
     */
    'siteName'?: SiteType | null;
    /**
     * 
     * @type {Array<Stage>}
     * @memberof Course
     */
    'stages'?: Array<Stage>;
    /**
     * 
     * @type {string}
     * @memberof Course
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof Course
     */
    'validTo'?: string;
}


/**
 * 
 * @export
 * @interface CourseDetailsList
 */
export interface CourseDetailsList {
    /**
     * List of courses with full details
     * @type {Array<Course>}
     * @memberof CourseDetailsList
     */
    'courses'?: Array<Course>;
}
/**
 * 
 * @export
 * @interface CourseDetailsListResponse
 */
export interface CourseDetailsListResponse {
    /**
     * 
     * @type {CourseDetailsList}
     * @memberof CourseDetailsListResponse
     */
    'data'?: CourseDetailsList;
    /**
     * Response message
     * @type {string}
     * @memberof CourseDetailsListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CourseDetailsListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CourseInfo
 */
export interface CourseInfo {
    /**
     * course code
     * @type {string}
     * @memberof CourseInfo
     */
    'code': string;
    /**
     * course description
     * @type {string}
     * @memberof CourseInfo
     */
    'description'?: string;
    /**
     * course name
     * @type {string}
     * @memberof CourseInfo
     */
    'name': string;
    /**
     * 
     * @type {SiteType}
     * @memberof CourseInfo
     */
    'siteName'?: SiteType | null;
    /**
     * 
     * @type {Array<StageInfo>}
     * @memberof CourseInfo
     */
    'stages'?: Array<StageInfo>;
    /**
     * 
     * @type {string}
     * @memberof CourseInfo
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseInfo
     */
    'validTo'?: string;
}


/**
 * 
 * @export
 * @interface CourseList
 */
export interface CourseList {
    /**
     * List of courses
     * @type {Array<CourseInfo>}
     * @memberof CourseList
     */
    'courses'?: Array<CourseInfo>;
}
/**
 * 
 * @export
 * @interface CourseListResponse
 */
export interface CourseListResponse {
    /**
     * 
     * @type {CourseList}
     * @memberof CourseListResponse
     */
    'data'?: CourseList;
    /**
     * Response message
     * @type {string}
     * @memberof CourseListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CourseListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateOperationResultRequest
 */
export interface CreateOperationResultRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOperationResultRequest
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface CreateOperationResultResponse
 */
export interface CreateOperationResultResponse {
    /**
     * 
     * @type {CreateOperationResultResponseData}
     * @memberof CreateOperationResultResponse
     */
    'data': CreateOperationResultResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CreateOperationResultResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CreateOperationResultResponse
     */
    'success'?: boolean;
}
/**
 * 作成結果のレスポンスデータ.
 * @export
 * @interface CreateOperationResultResponseData
 */
export interface CreateOperationResultResponseData {
    /**
     * 作成された operation_results レコードの一意の ID.
     * @type {number}
     * @memberof CreateOperationResultResponseData
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface CreateUserPlanHistoryRequest
 */
export interface CreateUserPlanHistoryRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserPlanHistoryRequest
     */
    'hasError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUserPlanHistoryRequest
     */
    'membershipType': CreateUserPlanHistoryRequestMembershipTypeEnum;
    /**
     * Start time of the plan.
     * @type {string}
     * @memberof CreateUserPlanHistoryRequest
     */
    'planStartedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserPlanHistoryRequest
     */
    'planType': CreateUserPlanHistoryRequestPlanTypeEnum;
}

export const CreateUserPlanHistoryRequestMembershipTypeEnum = {
    Free: 'free',
    Paid: 'paid',
    Manual: 'manual'
} as const;

export type CreateUserPlanHistoryRequestMembershipTypeEnum = typeof CreateUserPlanHistoryRequestMembershipTypeEnum[keyof typeof CreateUserPlanHistoryRequestMembershipTypeEnum];
export const CreateUserPlanHistoryRequestPlanTypeEnum = {
    Trial: 'trial',
    Annual: 'annual',
    Monthly: 'monthly',
    Prepaid: 'prepaid',
    Giftee30: 'giftee30',
    Giftee90: 'giftee90',
    Giftee365: 'giftee365',
    Unlimited: 'unlimited',
    License: 'license'
} as const;

export type CreateUserPlanHistoryRequestPlanTypeEnum = typeof CreateUserPlanHistoryRequestPlanTypeEnum[keyof typeof CreateUserPlanHistoryRequestPlanTypeEnum];

/**
 * 
 * @export
 * @interface CreateUserPlanHistoryResponse
 */
export interface CreateUserPlanHistoryResponse {
    /**
     * 
     * @type {CreateUserPlanHistoryResponseData}
     * @memberof CreateUserPlanHistoryResponse
     */
    'data': CreateUserPlanHistoryResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CreateUserPlanHistoryResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CreateUserPlanHistoryResponse
     */
    'success'?: boolean;
}
/**
 * Response data
 * @export
 * @interface CreateUserPlanHistoryResponseData
 */
export interface CreateUserPlanHistoryResponseData {
    /**
     * The unique ID of the user_plan_histories record.
     * @type {number}
     * @memberof CreateUserPlanHistoryResponseData
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface CreateUserTypeHistoryRequest
 */
export interface CreateUserTypeHistoryRequest {
    /**
     * 
     * @type {UserType}
     * @memberof CreateUserTypeHistoryRequest
     */
    'userType': UserType;
}


/**
 * 
 * @export
 * @interface CreateUserTypeHistoryResponse
 */
export interface CreateUserTypeHistoryResponse {
    /**
     * 
     * @type {CreateUserTypeHistoryResponseData}
     * @memberof CreateUserTypeHistoryResponse
     */
    'data': CreateUserTypeHistoryResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof CreateUserTypeHistoryResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof CreateUserTypeHistoryResponse
     */
    'success'?: boolean;
}
/**
 * Response data
 * @export
 * @interface CreateUserTypeHistoryResponseData
 */
export interface CreateUserTypeHistoryResponseData {
    /**
     * The unique ID of the user_type_histories record.
     * @type {number}
     * @memberof CreateUserTypeHistoryResponseData
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface CurrentChapterResult
 */
export interface CurrentChapterResult {
    /**
     * Chapter identifier
     * @type {number}
     * @memberof CurrentChapterResult
     */
    'chapterId': number;
}
/**
 * 
 * @export
 * @interface EventData
 */
export interface EventData {
    /**
     * Event code (e.g. \'typing-contest2026\')
     * @type {string}
     * @memberof EventData
     */
    'code': string;
    /**
     * Current event phase (announce, during, selection, result). Null if no active schedule.
     * @type {string}
     * @memberof EventData
     */
    'currentPhase'?: EventDataCurrentPhaseEnum | null;
    /**
     * 
     * @type {number}
     * @memberof EventData
     */
    'eventId': number;
    /**
     * Event name
     * @type {string}
     * @memberof EventData
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EventData
     */
    'phaseValidFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventData
     */
    'phaseValidTo'?: string | null;
    /**
     * Sub site code (e.g. \'typing\', \'micratch\')
     * @type {string}
     * @memberof EventData
     */
    'subSite': string;
}

export const EventDataCurrentPhaseEnum = {
    Announce: 'announce',
    During: 'during',
    Selection: 'selection',
    Result: 'result',
    Null: 'null'
} as const;

export type EventDataCurrentPhaseEnum = typeof EventDataCurrentPhaseEnum[keyof typeof EventDataCurrentPhaseEnum];

/**
 * 
 * @export
 * @interface EventEntryCreateRequest
 */
export interface EventEntryCreateRequest {
    /**
     * Entry type (1, 2). Optional.
     * @type {string}
     * @memberof EventEntryCreateRequest
     */
    'type'?: EventEntryCreateRequestTypeEnum | null;
}

export const EventEntryCreateRequestTypeEnum = {
    _1: '1',
    _2: '2',
    Null: 'null'
} as const;

export type EventEntryCreateRequestTypeEnum = typeof EventEntryCreateRequestTypeEnum[keyof typeof EventEntryCreateRequestTypeEnum];

/**
 * 
 * @export
 * @interface EventEntryCreateResponse
 */
export interface EventEntryCreateResponse {
    /**
     * 
     * @type {EventEntryCreateResponseData}
     * @memberof EventEntryCreateResponse
     */
    'data'?: EventEntryCreateResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof EventEntryCreateResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof EventEntryCreateResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface EventEntryCreateResponseData
 */
export interface EventEntryCreateResponseData {
    /**
     * 
     * @type {string}
     * @memberof EventEntryCreateResponseData
     */
    'createdAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof EventEntryCreateResponseData
     */
    'eventId': number;
    /**
     * 
     * @type {number}
     * @memberof EventEntryCreateResponseData
     */
    'id': number;
    /**
     * Entry type (1, 2)
     * @type {string}
     * @memberof EventEntryCreateResponseData
     */
    'type'?: EventEntryCreateResponseDataTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof EventEntryCreateResponseData
     */
    'userId': number;
}

export const EventEntryCreateResponseDataTypeEnum = {
    _1: '1',
    _2: '2',
    Null: 'null'
} as const;

export type EventEntryCreateResponseDataTypeEnum = typeof EventEntryCreateResponseDataTypeEnum[keyof typeof EventEntryCreateResponseDataTypeEnum];

/**
 * 
 * @export
 * @interface EventEntryData
 */
export interface EventEntryData {
    /**
     * 
     * @type {string}
     * @memberof EventEntryData
     */
    'createdAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof EventEntryData
     */
    'eventId': number;
    /**
     * 
     * @type {number}
     * @memberof EventEntryData
     */
    'id': number;
    /**
     * Entry type (1, 2)
     * @type {string}
     * @memberof EventEntryData
     */
    'type'?: EventEntryDataTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof EventEntryData
     */
    'userId': number;
}

export const EventEntryDataTypeEnum = {
    _1: '1',
    _2: '2',
    Null: 'null'
} as const;

export type EventEntryDataTypeEnum = typeof EventEntryDataTypeEnum[keyof typeof EventEntryDataTypeEnum];

/**
 * 
 * @export
 * @interface EventEntryListResponse
 */
export interface EventEntryListResponse {
    /**
     * 
     * @type {Array<EventEntryData>}
     * @memberof EventEntryListResponse
     */
    'data'?: Array<EventEntryData>;
    /**
     * Response message
     * @type {string}
     * @memberof EventEntryListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof EventEntryListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface EventListResponse
 */
export interface EventListResponse {
    /**
     * 
     * @type {Array<EventData>}
     * @memberof EventListResponse
     */
    'data'?: Array<EventData>;
    /**
     * Response message
     * @type {string}
     * @memberof EventListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof EventListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface GetAllChapterResults
 */
export interface GetAllChapterResults {
    /**
     * List of chapter results
     * @type {Array<CurrentChapterResult>}
     * @memberof GetAllChapterResults
     */
    'results'?: Array<CurrentChapterResult>;
}
/**
 * 
 * @export
 * @interface GetAllChapterResultsResponse
 */
export interface GetAllChapterResultsResponse {
    /**
     * 
     * @type {GetAllChapterResultsResponseData}
     * @memberof GetAllChapterResultsResponse
     */
    'data'?: GetAllChapterResultsResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof GetAllChapterResultsResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof GetAllChapterResultsResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface GetAllChapterResultsResponseData
 */
export interface GetAllChapterResultsResponseData {
    /**
     * List of chapter results
     * @type {Array<CurrentChapterResult>}
     * @memberof GetAllChapterResultsResponseData
     */
    'results'?: Array<CurrentChapterResult>;
}
/**
 * 
 * @export
 * @interface GetMissionResultData
 */
export interface GetMissionResultData {
    /**
     * 
     * @type {string}
     * @memberof GetMissionResultData
     */
    'courseName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMissionResultData
     */
    'createdAt': string;
    /**
     * Mission sequence number
     * @type {number}
     * @memberof GetMissionResultData
     */
    'missionSeq': number;
    /**
     * 
     * @type {string}
     * @memberof GetMissionResultData
     */
    'stageName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMissionResultData
     */
    'thumbnailUrl'?: string;
}
/**
 * 
 * @export
 * @interface GetMissionResultDataResponse
 */
export interface GetMissionResultDataResponse {
    /**
     * 
     * @type {GetMissionResultData}
     * @memberof GetMissionResultDataResponse
     */
    'data'?: GetMissionResultData;
    /**
     * Response message
     * @type {string}
     * @memberof GetMissionResultDataResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof GetMissionResultDataResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface GetRewardListResponse
 */
export interface GetRewardListResponse {
    /**
     * 
     * @type {Array<Reward>}
     * @memberof GetRewardListResponse
     */
    'data'?: Array<Reward>;
    /**
     * Response message
     * @type {string}
     * @memberof GetRewardListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof GetRewardListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface GetStampListResponse
 */
export interface GetStampListResponse {
    /**
     * 
     * @type {Array<Stamp>}
     * @memberof GetStampListResponse
     */
    'data'?: Array<Stamp>;
    /**
     * Response message
     * @type {string}
     * @memberof GetStampListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof GetStampListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface GetUnacquiredMissionsResponse
 */
export interface GetUnacquiredMissionsResponse {
    /**
     * 
     * @type {GetUnacquiredMissionsResponseData}
     * @memberof GetUnacquiredMissionsResponse
     */
    'data'?: GetUnacquiredMissionsResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof GetUnacquiredMissionsResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof GetUnacquiredMissionsResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface GetUnacquiredMissionsResponseData
 */
export interface GetUnacquiredMissionsResponseData {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetUnacquiredMissionsResponseData
     */
    'missionIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface GetUserNickname
 */
export interface GetUserNickname {
    /**
     * User nickname
     * @type {string}
     * @memberof GetUserNickname
     */
    'nickname': string;
}
/**
 * 
 * @export
 * @interface GetUserNicknameResponse
 */
export interface GetUserNicknameResponse {
    /**
     * 
     * @type {GetUserNickname}
     * @memberof GetUserNicknameResponse
     */
    'data'?: GetUserNickname;
    /**
     * Response message
     * @type {string}
     * @memberof GetUserNicknameResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof GetUserNicknameResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface GetUserProfileData
 */
export interface GetUserProfileData {
    /**
     * User nickname
     * @type {string}
     * @memberof GetUserProfileData
     */
    'nickname': string;
    /**
     * User icon URL
     * @type {string}
     * @memberof GetUserProfileData
     */
    'userIconUrl': string;
    /**
     * User ID
     * @type {number}
     * @memberof GetUserProfileData
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface GetUserProfilesRequest
 */
export interface GetUserProfilesRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetUserProfilesRequest
     */
    'userIds': Array<number>;
}
/**
 * 
 * @export
 * @interface GetUserProfilesResponse
 */
export interface GetUserProfilesResponse {
    /**
     * 
     * @type {Array<GetUserProfileData>}
     * @memberof GetUserProfilesResponse
     */
    'data'?: Array<GetUserProfileData>;
    /**
     * Response message
     * @type {string}
     * @memberof GetUserProfilesResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof GetUserProfilesResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface GetUserRewardsData
 */
export interface GetUserRewardsData {
    /**
     * 
     * @type {string}
     * @memberof GetUserRewardsData
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserRewardsData
     */
    'isAcquired': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserRewardsData
     */
    'rewardCode': string;
}
/**
 * 
 * @export
 * @interface GetUserRewardsResponse
 */
export interface GetUserRewardsResponse {
    /**
     * 
     * @type {Array<GetUserRewardsData>}
     * @memberof GetUserRewardsResponse
     */
    'data'?: Array<GetUserRewardsData>;
    /**
     * Response message
     * @type {string}
     * @memberof GetUserRewardsResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof GetUserRewardsResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface GetUserStampsResponse
 */
export interface GetUserStampsResponse {
    /**
     * 
     * @type {Array<UserStampData>}
     * @memberof GetUserStampsResponse
     */
    'data'?: Array<UserStampData>;
    /**
     * Response message
     * @type {string}
     * @memberof GetUserStampsResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof GetUserStampsResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface GetUserTotalExpResponse
 */
export interface GetUserTotalExpResponse {
    /**
     * レスポンスデータ
     * @type {GetUserTotalExpResponseData}
     * @memberof GetUserTotalExpResponse
     */
    'data': GetUserTotalExpResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof GetUserTotalExpResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof GetUserTotalExpResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface GetUserTotalExpResponseData
 */
export interface GetUserTotalExpResponseData {
    /**
     * User Total Exp
     * @type {number}
     * @memberof GetUserTotalExpResponseData
     */
    'totalExp': number;
    /**
     * User Level calculated from total_exp
     * @type {number}
     * @memberof GetUserTotalExpResponseData
     */
    'userLevel': number;
}
/**
 * 
 * @export
 * @interface LearningLogItem
 */
export interface LearningLogItem {
    /**
     * 
     * @type {string}
     * @memberof LearningLogItem
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningLogItem
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof LearningLogItem
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof LearningLogItem
     */
    'expId'?: number;
    /**
     * 
     * @type {number}
     * @memberof LearningLogItem
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof LearningLogItem
     */
    'imagePath'?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningLogItem
     */
    'learningSummary'?: string;
    /**
     * 
     * @type {number}
     * @memberof LearningLogItem
     */
    'point'?: number;
    /**
     * 
     * @type {string}
     * @memberof LearningLogItem
     */
    'stampType'?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningLogItem
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface LearningLogsListResponse
 */
export interface LearningLogsListResponse {
    /**
     * 
     * @type {Array<LearningLogItem>}
     * @memberof LearningLogsListResponse
     */
    'data'?: Array<LearningLogItem>;
    /**
     * Response message
     * @type {string}
     * @memberof LearningLogsListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof LearningLogsListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface Login
 */
export interface Login {
    /**
     * 
     * @type {LoginUser}
     * @memberof Login
     */
    'user'?: LoginUser;
}
/**
 * 
 * @export
 * @interface LoginGoogleRequest
 */
export interface LoginGoogleRequest {
    /**
     * Access token
     * @type {string}
     * @memberof LoginGoogleRequest
     */
    'accessToken': string;
    /**
     * Site type: \'admin\'
     * @type {string}
     * @memberof LoginGoogleRequest
     */
    'siteName': LoginGoogleRequestSiteNameEnum;
}

export const LoginGoogleRequestSiteNameEnum = {
    Admin: 'admin'
} as const;

export type LoginGoogleRequestSiteNameEnum = typeof LoginGoogleRequestSiteNameEnum[keyof typeof LoginGoogleRequestSiteNameEnum];

/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {SiteType}
     * @memberof LoginRequest
     */
    'siteName': SiteType;
    /**
     * WordPress user email
     * @type {string}
     * @memberof LoginRequest
     */
    'wpUserEmail': string;
    /**
     * WordPress user ID
     * @type {number}
     * @memberof LoginRequest
     */
    'wpUserId': number;
    /**
     * WordPress user password
     * @type {string}
     * @memberof LoginRequest
     */
    'wpUserPass': string;
}


/**
 * 
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
    /**
     * 
     * @type {Login}
     * @memberof LoginResponse
     */
    'data'?: Login;
    /**
     * Response message
     * @type {string}
     * @memberof LoginResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof LoginResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface LoginUser
 */
export interface LoginUser {
    /**
     * User birthdate
     * @type {string}
     * @memberof LoginUser
     */
    'birthdate'?: string | null;
    /**
     * User ID
     * @type {number}
     * @memberof LoginUser
     */
    'id': number;
    /**
     * User membership type
     * @type {string}
     * @memberof LoginUser
     */
    'membershipType'?: string | null;
    /**
     * User nickname
     * @type {string}
     * @memberof LoginUser
     */
    'nickname'?: string | null;
    /**
     * Site name
     * @type {string}
     * @memberof LoginUser
     */
    'siteName': string;
}
/**
 * 
 * @export
 * @interface Logout
 */
export interface Logout {
    /**
     * Logout result message
     * @type {string}
     * @memberof Logout
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface LogoutResponse
 */
export interface LogoutResponse {
    /**
     * 
     * @type {Logout}
     * @memberof LogoutResponse
     */
    'data'?: Logout;
    /**
     * Response message
     * @type {string}
     * @memberof LogoutResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof LogoutResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface Mission
 */
export interface Mission {
    /**
     * mission answer_document_url
     * @type {string}
     * @memberof Mission
     */
    'answer'?: string | null;
    /**
     * List of chapters
     * @type {Array<Chapter>}
     * @memberof Mission
     */
    'chapters': Array<Chapter>;
    /**
     * course name
     * @type {string}
     * @memberof Mission
     */
    'course'?: string | null;
    /**
     * mission description
     * @type {string}
     * @memberof Mission
     */
    'desc'?: string | null;
    /**
     * device
     * @type {Array<string>}
     * @memberof Mission
     */
    'device'?: Array<string>;
    /**
     * mission document_url
     * @type {string}
     * @memberof Mission
     */
    'dlPdf'?: string | null;
    /**
     * mission asset_download_url
     * @type {string}
     * @memberof Mission
     */
    'dlUrl'?: string | null;
    /**
     * mission exercise_url
     * @type {string}
     * @memberof Mission
     */
    'exercise'?: string | null;
    /**
     * mission sample_game_url
     * @type {string}
     * @memberof Mission
     */
    'gameSample'?: string | null;
    /**
     * mission sample_game_name
     * @type {string}
     * @memberof Mission
     */
    'gameSampleName'?: string | null;
    /**
     * mission id
     * @type {number}
     * @memberof Mission
     */
    'id': number;
    /**
     * language
     * @type {string}
     * @memberof Mission
     */
    'language'?: string | null;
    /**
     * learning_summary
     * @type {string}
     * @memberof Mission
     */
    'learned'?: string | null;
    /**
     * mission level
     * @type {string}
     * @memberof Mission
     */
    'level'?: string | null;
    /**
     * mission seq
     * @type {number}
     * @memberof Mission
     */
    'num'?: number | null;
    /**
     * is_unlocked
     * @type {boolean}
     * @memberof Mission
     */
    '_private'?: boolean | null;
    /**
     * mission sample_program_url
     * @type {string}
     * @memberof Mission
     */
    'sample'?: string | null;
    /**
     * site name (online or license)
     * @type {string}
     * @memberof Mission
     */
    'siteName'?: string | null;
    /**
     * stage code
     * @type {string}
     * @memberof Mission
     */
    'slug'?: string | null;
    /**
     * stage name
     * @type {string}
     * @memberof Mission
     */
    'stage'?: string | null;
    /**
     * stage sequence number
     * @type {number}
     * @memberof Mission
     */
    'stageSeq'?: number | null;
    /**
     * target
     * @type {string}
     * @memberof Mission
     */
    'target'?: string | null;
    /**
     * mission thumbnail url
     * @type {string}
     * @memberof Mission
     */
    'thum'?: string | null;
    /**
     * viewing_minutes
     * @type {string}
     * @memberof Mission
     */
    'time'?: string | null;
    /**
     * mission title
     * @type {string}
     * @memberof Mission
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Mission
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof Mission
     */
    'validTo'?: string;
}
/**
 * 
 * @export
 * @interface MissionInfo
 */
export interface MissionInfo {
    /**
     * Mission name
     * @type {string}
     * @memberof MissionInfo
     */
    'missionName': string;
    /**
     * Mission sequence number
     * @type {number}
     * @memberof MissionInfo
     */
    'missionSeq': number;
    /**
     * Stage sequence number
     * @type {number}
     * @memberof MissionInfo
     */
    'stageSeq': number;
}
/**
 * 
 * @export
 * @interface MissionInfoResponse
 */
export interface MissionInfoResponse {
    /**
     * 
     * @type {MissionInfoResponseData}
     * @memberof MissionInfoResponse
     */
    'data'?: MissionInfoResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof MissionInfoResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof MissionInfoResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface MissionInfoResponseData
 */
export interface MissionInfoResponseData {
    /**
     * Mission name
     * @type {string}
     * @memberof MissionInfoResponseData
     */
    'missionName': string;
    /**
     * Mission sequence number
     * @type {number}
     * @memberof MissionInfoResponseData
     */
    'missionSeq': number;
    /**
     * Stage sequence number
     * @type {number}
     * @memberof MissionInfoResponseData
     */
    'stageSeq': number;
}
/**
 * 
 * @export
 * @interface MissionProgressData
 */
export interface MissionProgressData {
    /**
     * Number of completed chapters
     * @type {number}
     * @memberof MissionProgressData
     */
    'completedChaptersCount': number;
    /**
     * Mission ID
     * @type {number}
     * @memberof MissionProgressData
     */
    'missionId': number;
    /**
     * Total number of chapters
     * @type {number}
     * @memberof MissionProgressData
     */
    'totalChapters': number;
}
/**
 * 
 * @export
 * @interface MissionProgressResponse
 */
export interface MissionProgressResponse {
    /**
     * Mission progress data with site information
     * @type {MissionProgressResponseData}
     * @memberof MissionProgressResponse
     */
    'data': MissionProgressResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof MissionProgressResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof MissionProgressResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface MissionProgressResponseData
 */
export interface MissionProgressResponseData {
    /**
     * List of user mission progress data
     * @type {Array<UserMissionProgressData>}
     * @memberof MissionProgressResponseData
     */
    'users': Array<UserMissionProgressData>;
}
/**
 * 
 * @export
 * @interface MissionResponse
 */
export interface MissionResponse {
    /**
     * 
     * @type {MissionResponseData}
     * @memberof MissionResponse
     */
    'data'?: MissionResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof MissionResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof MissionResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface MissionResponseData
 */
export interface MissionResponseData {
    /**
     * mission answer_document_url
     * @type {string}
     * @memberof MissionResponseData
     */
    'answer'?: string | null;
    /**
     * List of chapters
     * @type {Array<Chapter>}
     * @memberof MissionResponseData
     */
    'chapters': Array<Chapter>;
    /**
     * course name
     * @type {string}
     * @memberof MissionResponseData
     */
    'course'?: string | null;
    /**
     * mission description
     * @type {string}
     * @memberof MissionResponseData
     */
    'desc'?: string | null;
    /**
     * device
     * @type {Array<string>}
     * @memberof MissionResponseData
     */
    'device'?: Array<string>;
    /**
     * mission document_url
     * @type {string}
     * @memberof MissionResponseData
     */
    'dlPdf'?: string | null;
    /**
     * mission asset_download_url
     * @type {string}
     * @memberof MissionResponseData
     */
    'dlUrl'?: string | null;
    /**
     * mission exercise_url
     * @type {string}
     * @memberof MissionResponseData
     */
    'exercise'?: string | null;
    /**
     * mission sample_game_url
     * @type {string}
     * @memberof MissionResponseData
     */
    'gameSample'?: string | null;
    /**
     * mission sample_game_name
     * @type {string}
     * @memberof MissionResponseData
     */
    'gameSampleName'?: string | null;
    /**
     * mission id
     * @type {number}
     * @memberof MissionResponseData
     */
    'id': number;
    /**
     * language
     * @type {string}
     * @memberof MissionResponseData
     */
    'language'?: string | null;
    /**
     * learning_summary
     * @type {string}
     * @memberof MissionResponseData
     */
    'learned'?: string | null;
    /**
     * mission level
     * @type {string}
     * @memberof MissionResponseData
     */
    'level'?: string | null;
    /**
     * mission seq
     * @type {number}
     * @memberof MissionResponseData
     */
    'num'?: number | null;
    /**
     * is_unlocked
     * @type {boolean}
     * @memberof MissionResponseData
     */
    '_private'?: boolean | null;
    /**
     * mission sample_program_url
     * @type {string}
     * @memberof MissionResponseData
     */
    'sample'?: string | null;
    /**
     * site name (online or license)
     * @type {string}
     * @memberof MissionResponseData
     */
    'siteName'?: string | null;
    /**
     * stage code
     * @type {string}
     * @memberof MissionResponseData
     */
    'slug'?: string | null;
    /**
     * stage name
     * @type {string}
     * @memberof MissionResponseData
     */
    'stage'?: string | null;
    /**
     * stage sequence number
     * @type {number}
     * @memberof MissionResponseData
     */
    'stageSeq'?: number | null;
    /**
     * target
     * @type {string}
     * @memberof MissionResponseData
     */
    'target'?: string | null;
    /**
     * mission thumbnail url
     * @type {string}
     * @memberof MissionResponseData
     */
    'thum'?: string | null;
    /**
     * viewing_minutes
     * @type {string}
     * @memberof MissionResponseData
     */
    'time'?: string | null;
    /**
     * mission title
     * @type {string}
     * @memberof MissionResponseData
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof MissionResponseData
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof MissionResponseData
     */
    'validTo'?: string;
}
/**
 * 
 * @export
 * @interface MissionRewardsData
 */
export interface MissionRewardsData {
    /**
     * 
     * @type {number}
     * @memberof MissionRewardsData
     */
    'exp': number;
    /**
     * 
     * @type {string}
     * @memberof MissionRewardsData
     */
    'missionId': string;
    /**
     * 
     * @type {Array<Reward>}
     * @memberof MissionRewardsData
     */
    'rewards'?: Array<Reward>;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * Error code
     * @type {number}
     * @memberof ModelError
     */
    'code'?: number;
    /**
     * Errors
     * @type {{ [key: string]: any; }}
     * @memberof ModelError
     */
    'errors'?: { [key: string]: any; };
    /**
     * Error message
     * @type {string}
     * @memberof ModelError
     */
    'message'?: string;
    /**
     * Error name
     * @type {string}
     * @memberof ModelError
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface MultipleUserMissionProgressRequest
 */
export interface MultipleUserMissionProgressRequest {
    /**
     * 
     * @type {SiteType}
     * @memberof MultipleUserMissionProgressRequest
     */
    'siteName': SiteType;
    /**
     * List of user-mission pairs
     * @type {Array<UserMissionPair>}
     * @memberof MultipleUserMissionProgressRequest
     */
    'userMissions': Array<UserMissionPair>;
}


/**
 * 
 * @export
 * @interface OverviewMission
 */
export interface OverviewMission {
    /**
     * mission id
     * @type {number}
     * @memberof OverviewMission
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewMission
     */
    'num'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OverviewMission
     */
    '_private'?: boolean;
    /**
     * mission title
     * @type {string}
     * @memberof OverviewMission
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface OverviewStage
 */
export interface OverviewStage {
    /**
     * stage code
     * @type {string}
     * @memberof OverviewStage
     */
    'code': string;
    /**
     * List of simplified missions
     * @type {Array<OverviewMission>}
     * @memberof OverviewStage
     */
    'missions': Array<OverviewMission>;
}
/**
 * 
 * @export
 * @interface OverviewStageList
 */
export interface OverviewStageList {
    /**
     * List of overview stages
     * @type {Array<OverviewStage>}
     * @memberof OverviewStageList
     */
    'stages'?: Array<OverviewStage>;
}
/**
 * 
 * @export
 * @interface OverviewStageListResponse
 */
export interface OverviewStageListResponse {
    /**
     * 
     * @type {OverviewStageList}
     * @memberof OverviewStageListResponse
     */
    'data'?: OverviewStageList;
    /**
     * Response message
     * @type {string}
     * @memberof OverviewStageListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof OverviewStageListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface PaginationMetadata
 */
export interface PaginationMetadata {
    /**
     * 
     * @type {number}
     * @memberof PaginationMetadata
     */
    'firstPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetadata
     */
    'lastPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetadata
     */
    'nextPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetadata
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetadata
     */
    'previousPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetadata
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetadata
     */
    'totalPages'?: number;
}
/**
 * 
 * @export
 * @interface PatchUserRequest
 */
export interface PatchUserRequest {
    /**
     * User birthdate
     * @type {string}
     * @memberof PatchUserRequest
     */
    'birthdate'?: string | null;
    /**
     * User Line ID
     * @type {string}
     * @memberof PatchUserRequest
     */
    'lineId'?: string | null;
    /**
     * User nickname
     * @type {string}
     * @memberof PatchUserRequest
     */
    'nickname'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchUserResponse
 */
export interface PatchUserResponse {
    /**
     * 
     * @type {User}
     * @memberof PatchUserResponse
     */
    'data'?: User;
    /**
     * Response message
     * @type {string}
     * @memberof PatchUserResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof PatchUserResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface PostChapterResultRequest
 */
export interface PostChapterResultRequest {
    /**
     * Registered user ID
     * @type {number}
     * @memberof PostChapterResultRequest
     */
    'chapterId': number;
}
/**
 * 
 * @export
 * @interface PostChapterResultResponse
 */
export interface PostChapterResultResponse {
    /**
     * 
     * @type {PostChapterResultResponseData}
     * @memberof PostChapterResultResponse
     */
    'data'?: PostChapterResultResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof PostChapterResultResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof PostChapterResultResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface PostChapterResultResponseData
 */
export interface PostChapterResultResponseData {
    /**
     * 
     * @type {ChapterRewardsData}
     * @memberof PostChapterResultResponseData
     */
    'chapterResult': ChapterRewardsData;
    /**
     * 
     * @type {MissionRewardsData}
     * @memberof PostChapterResultResponseData
     */
    'missionResult': MissionRewardsData;
    /**
     * 
     * @type {string}
     * @memberof PostChapterResultResponseData
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface PostUserRewardsRequest
 */
export interface PostUserRewardsRequest {
    /**
     * 
     * @type {string}
     * @memberof PostUserRewardsRequest
     */
    'rewardCode': string;
}
/**
 * 
 * @export
 * @interface PostUserRewardsResponse
 */
export interface PostUserRewardsResponse {
    /**
     * レスポンスデータ
     * @type {PostUserRewardsResponseData}
     * @memberof PostUserRewardsResponse
     */
    'data': PostUserRewardsResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof PostUserRewardsResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof PostUserRewardsResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface PostUserRewardsResponseData
 */
export interface PostUserRewardsResponseData {
    /**
     * User Reward ID.
     * @type {number}
     * @memberof PostUserRewardsResponseData
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface PostUserStampsRequest
 */
export interface PostUserStampsRequest {
    /**
     * 
     * @type {string}
     * @memberof PostUserStampsRequest
     */
    'message'?: string;
    /**
     * Stamp ID.
     * @type {number}
     * @memberof PostUserStampsRequest
     */
    'stampId': number;
}
/**
 * 
 * @export
 * @interface PostUserStampsResponse
 */
export interface PostUserStampsResponse {
    /**
     * レスポンスデータ
     * @type {UserStampData}
     * @memberof PostUserStampsResponse
     */
    'data': UserStampData;
    /**
     * Response message
     * @type {string}
     * @memberof PostUserStampsResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof PostUserStampsResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface PresignedUrlData
 */
export interface PresignedUrlData {
    /**
     * S3 object key
     * @type {string}
     * @memberof PresignedUrlData
     */
    'key': string;
    /**
     * S3 Presigned URL for uploading
     * @type {string}
     * @memberof PresignedUrlData
     */
    'presignedUrl': string;
    /**
     * Public URL of the uploaded file
     * @type {string}
     * @memberof PresignedUrlData
     */
    'publicUrl': string;
}
/**
 * 
 * @export
 * @interface PresignedUrlRequest
 */
export interface PresignedUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof PresignedUrlRequest
     */
    'contentType': string;
    /**
     * 
     * @type {string}
     * @memberof PresignedUrlRequest
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof PresignedUrlRequest
     */
    'folder'?: string;
}
/**
 * 
 * @export
 * @interface PresignedUrlResponse
 */
export interface PresignedUrlResponse {
    /**
     * 
     * @type {PresignedUrlResponseData}
     * @memberof PresignedUrlResponse
     */
    'data'?: PresignedUrlResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof PresignedUrlResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof PresignedUrlResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface PresignedUrlResponseData
 */
export interface PresignedUrlResponseData {
    /**
     * S3 object key
     * @type {string}
     * @memberof PresignedUrlResponseData
     */
    'key': string;
    /**
     * S3 Presigned URL for uploading
     * @type {string}
     * @memberof PresignedUrlResponseData
     */
    'presignedUrl': string;
    /**
     * Public URL of the uploaded file
     * @type {string}
     * @memberof PresignedUrlResponseData
     */
    'publicUrl': string;
}
/**
 * 
 * @export
 * @interface RecommendMissionResponse
 */
export interface RecommendMissionResponse {
    /**
     * 次のミッション情報
     * @type {RecommendMissionResponseData}
     * @memberof RecommendMissionResponse
     */
    'data': RecommendMissionResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof RecommendMissionResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof RecommendMissionResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface RecommendMissionResponseData
 */
export interface RecommendMissionResponseData {
    /**
     * Is mission completed
     * @type {boolean}
     * @memberof RecommendMissionResponseData
     */
    'isCompleted': boolean;
    /**
     * Mission sequence number
     * @type {number}
     * @memberof RecommendMissionResponseData
     */
    'missionSeq': number;
    /**
     * Stage code
     * @type {string}
     * @memberof RecommendMissionResponseData
     */
    'stageCode': string;
}
/**
 * 
 * @export
 * @interface RegisterUser
 */
export interface RegisterUser {
    /**
     * Registered user ID
     * @type {number}
     * @memberof RegisterUser
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface RegisterUserRequest
 */
export interface RegisterUserRequest {
    /**
     * user nickname
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'nickname'?: string;
    /**
     * 
     * @type {SiteType}
     * @memberof RegisterUserRequest
     */
    'siteName': SiteType;
    /**
     * WordPress user email
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'wpUserEmail': string;
    /**
     * WordPress user ID
     * @type {number}
     * @memberof RegisterUserRequest
     */
    'wpUserId': number;
    /**
     * WordPress user password
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'wpUserPass': string;
}


/**
 * 
 * @export
 * @interface RegisterUserResponse
 */
export interface RegisterUserResponse {
    /**
     * Response data
     * @type {RegisterUser}
     * @memberof RegisterUserResponse
     */
    'data': RegisterUser;
    /**
     * Response message
     * @type {string}
     * @memberof RegisterUserResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof RegisterUserResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface Reward
 */
export interface Reward {
    /**
     * Code
     * @type {string}
     * @memberof Reward
     */
    'code': string;
    /**
     * Description
     * @type {string}
     * @memberof Reward
     */
    'description': string;
    /**
     * Experience Point ID
     * @type {number}
     * @memberof Reward
     */
    'id': number;
    /**
     * Reward Image Storage Path
     * @type {string}
     * @memberof Reward
     */
    'imgPath': string;
    /**
     * 
     * @type {string}
     * @memberof Reward
     */
    'rewardType': RewardRewardTypeEnum;
}

export const RewardRewardTypeEnum = {
    Badge: 'BADGE'
} as const;

export type RewardRewardTypeEnum = typeof RewardRewardTypeEnum[keyof typeof RewardRewardTypeEnum];

/**
 * 
 * @export
 * @interface SendVideoResponse
 */
export interface SendVideoResponse {
    /**
     * S3 URL of the uploaded video
     * @type {string}
     * @memberof SendVideoResponse
     */
    's3Url': string;
}
/**
 * 
 * @export
 * @interface Setup
 */
export interface Setup {
    /**
     * setup description
     * @type {string}
     * @memberof Setup
     */
    'desc'?: string | null;
    /**
     * target devices
     * @type {Array<string>}
     * @memberof Setup
     */
    'device'?: Array<string>;
    /**
     * setup hidden_mission_list
     * @type {boolean}
     * @memberof Setup
     */
    'hiddenMissionList'?: boolean | null;
    /**
     * setup id
     * @type {number}
     * @memberof Setup
     */
    'id': number;
    /**
     * setup seq
     * @type {number}
     * @memberof Setup
     */
    'num'?: number | null;
    /**
     * stage code
     * @type {string}
     * @memberof Setup
     */
    'slug'?: string | null;
    /**
     * setup viewing_minutes
     * @type {string}
     * @memberof Setup
     */
    'time'?: string | null;
    /**
     * setup title
     * @type {string}
     * @memberof Setup
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface SetupList
 */
export interface SetupList {
    /**
     * List of setups
     * @type {Array<Setup>}
     * @memberof SetupList
     */
    'setups'?: Array<Setup>;
}
/**
 * 
 * @export
 * @interface SetupListResponse
 */
export interface SetupListResponse {
    /**
     * 
     * @type {SetupList}
     * @memberof SetupListResponse
     */
    'data'?: SetupList;
    /**
     * Response message
     * @type {string}
     * @memberof SetupListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof SetupListResponse
     */
    'success'?: boolean;
}
/**
 * Site type identifier
 * @export
 * @enum {string}
 */

export const SiteType = {
    Online: 'online',
    License: 'license'
} as const;

export type SiteType = typeof SiteType[keyof typeof SiteType];


/**
 * SSO site identifier
 * @export
 * @enum {string}
 */

export const SsoSite = {
    Admin: 'admin'
} as const;

export type SsoSite = typeof SsoSite[keyof typeof SsoSite];


/**
 * 
 * @export
 * @interface Stage
 */
export interface Stage {
    /**
     * stage code
     * @type {string}
     * @memberof Stage
     */
    'code': string;
    /**
     * course code
     * @type {string}
     * @memberof Stage
     */
    'courseCode': string;
    /**
     * course description
     * @type {string}
     * @memberof Stage
     */
    'courseDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Stage
     */
    'courseId'?: number;
    /**
     * course name
     * @type {string}
     * @memberof Stage
     */
    'courseName': string;
    /**
     * List of missions
     * @type {Array<Mission>}
     * @memberof Stage
     */
    'missions': Array<Mission>;
    /**
     * stage name
     * @type {string}
     * @memberof Stage
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Stage
     */
    'seq'?: number;
    /**
     * site name
     * @type {string}
     * @memberof Stage
     */
    'siteName': string;
    /**
     * stage thumbnail url
     * @type {string}
     * @memberof Stage
     */
    'thumbnailUrl': string;
    /**
     * 
     * @type {string}
     * @memberof Stage
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof Stage
     */
    'validTo'?: string;
}
/**
 * 
 * @export
 * @interface StageInfo
 */
export interface StageInfo {
    /**
     * stage code
     * @type {string}
     * @memberof StageInfo
     */
    'code': string;
    /**
     * stage name
     * @type {string}
     * @memberof StageInfo
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof StageInfo
     */
    'seq'?: number;
}
/**
 * 
 * @export
 * @interface StageList
 */
export interface StageList {
    /**
     * List of stages
     * @type {Array<Stage>}
     * @memberof StageList
     */
    'stages'?: Array<Stage>;
}
/**
 * 
 * @export
 * @interface StageListResponse
 */
export interface StageListResponse {
    /**
     * 
     * @type {StageList}
     * @memberof StageListResponse
     */
    'data'?: StageList;
    /**
     * Response message
     * @type {string}
     * @memberof StageListResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof StageListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface Stamp
 */
export interface Stamp {
    /**
     * stamp ID
     * @type {string}
     * @memberof Stamp
     */
    'description': string;
    /**
     * stamp ID
     * @type {number}
     * @memberof Stamp
     */
    'id': number;
    /**
     * Stamp Image Storage Path
     * @type {string}
     * @memberof Stamp
     */
    'imgPath': string;
    /**
     * 
     * @type {string}
     * @memberof Stamp
     */
    'stampType': string;
}
/**
 * 
 * @export
 * @interface StudyCourseData
 */
export interface StudyCourseData {
    /**
     * 学習コースID
     * @type {number}
     * @memberof StudyCourseData
     */
    'id': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof StudyCourseData
     */
    'targetMissionIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface StudyCourseItemData
 */
export interface StudyCourseItemData {
    /**
     * 
     * @type {number}
     * @memberof StudyCourseItemData
     */
    'clearPointLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StudyCourseItemData
     */
    'code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StudyCourseItemData
     */
    'courseId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StudyCourseItemData
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyCourseItemData
     */
    'device'?: string | null;
    /**
     * 学習コースID
     * @type {number}
     * @memberof StudyCourseItemData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof StudyCourseItemData
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof StudyCourseItemData
     */
    'seq'?: number | null;
    /**
     * 学習モードID
     * @type {number}
     * @memberof StudyCourseItemData
     */
    'studyModeId': number;
    /**
     * 
     * @type {string}
     * @memberof StudyCourseItemData
     */
    'target'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyCourseItemData
     */
    'themeColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyCourseItemData
     */
    'thumbnailUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyCourseItemData
     */
    'validFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyCourseItemData
     */
    'validTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyCourseItemData
     */
    'videoCode'?: string | null;
}
/**
 * 
 * @export
 * @interface StudyModeItemData
 */
export interface StudyModeItemData {
    /**
     * 
     * @type {Array<StudyCourseItemData>}
     * @memberof StudyModeItemData
     */
    'courses': Array<StudyCourseItemData>;
    /**
     * 学習モードID
     * @type {number}
     * @memberof StudyModeItemData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof StudyModeItemData
     */
    'modeType': string;
    /**
     * 
     * @type {string}
     * @memberof StudyModeItemData
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof StudyModeItemData
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof StudyModeItemData
     */
    'validTo'?: string | null;
}
/**
 * 
 * @export
 * @interface StudyModeItems
 */
export interface StudyModeItems {
    /**
     * 
     * @type {Array<StudyModeItemData>}
     * @memberof StudyModeItems
     */
    'modes': Array<StudyModeItemData>;
}
/**
 * 
 * @export
 * @interface StudyModeItemsResponse
 */
export interface StudyModeItemsResponse {
    /**
     * 学習モード一覧データ
     * @type {StudyModeItems}
     * @memberof StudyModeItemsResponse
     */
    'data': StudyModeItems;
    /**
     * Response message
     * @type {string}
     * @memberof StudyModeItemsResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof StudyModeItemsResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingBestScore
 */
export interface TypingBestScore {
    /**
     * 
     * @type {number}
     * @memberof TypingBestScore
     */
    'bestScore'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypingBestScore
     */
    'themeName': string;
    /**
     * 
     * @type {string}
     * @memberof TypingBestScore
     */
    'themeType': TypingBestScoreThemeTypeEnum;
}

export const TypingBestScoreThemeTypeEnum = {
    Disney: 'disney',
    Micratch: 'micratch',
    Roblox: 'roblox'
} as const;

export type TypingBestScoreThemeTypeEnum = typeof TypingBestScoreThemeTypeEnum[keyof typeof TypingBestScoreThemeTypeEnum];

/**
 * 
 * @export
 * @interface TypingCharacter
 */
export interface TypingCharacter {
    /**
     * 
     * @type {string}
     * @memberof TypingCharacter
     */
    'characterType': string;
    /**
     * 
     * @type {number}
     * @memberof TypingCharacter
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TypingCurrentGrade
 */
export interface TypingCurrentGrade {
    /**
     * 
     * @type {number}
     * @memberof TypingCurrentGrade
     */
    'clearedGrade'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypingCurrentGrade
     */
    'themeType': TypingCurrentGradeThemeTypeEnum;
}

export const TypingCurrentGradeThemeTypeEnum = {
    Disney: 'disney',
    Micratch: 'micratch',
    Roblox: 'roblox'
} as const;

export type TypingCurrentGradeThemeTypeEnum = typeof TypingCurrentGradeThemeTypeEnum[keyof typeof TypingCurrentGradeThemeTypeEnum];

/**
 * 
 * @export
 * @interface TypingDeleteGrade
 */
export interface TypingDeleteGrade {
    /**
     * 
     * @type {number}
     * @memberof TypingDeleteGrade
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TypingDeleteGradeResponse
 */
export interface TypingDeleteGradeResponse {
    /**
     * 
     * @type {TypingDeleteGradeResponseData}
     * @memberof TypingDeleteGradeResponse
     */
    'data'?: TypingDeleteGradeResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof TypingDeleteGradeResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingDeleteGradeResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingDeleteGradeResponseData
 */
export interface TypingDeleteGradeResponseData {
    /**
     * 
     * @type {number}
     * @memberof TypingDeleteGradeResponseData
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TypingDeleteWord
 */
export interface TypingDeleteWord {
    /**
     * 
     * @type {number}
     * @memberof TypingDeleteWord
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface TypingDeleteWordResponse
 */
export interface TypingDeleteWordResponse {
    /**
     * 
     * @type {TypingDeleteWordResponseData}
     * @memberof TypingDeleteWordResponse
     */
    'data'?: TypingDeleteWordResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof TypingDeleteWordResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingDeleteWordResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingDeleteWordResponseData
 */
export interface TypingDeleteWordResponseData {
    /**
     * 
     * @type {number}
     * @memberof TypingDeleteWordResponseData
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface TypingGetBestScoresResponse
 */
export interface TypingGetBestScoresResponse {
    /**
     * 
     * @type {Array<TypingBestScore>}
     * @memberof TypingGetBestScoresResponse
     */
    'data': Array<TypingBestScore>;
    /**
     * Response message
     * @type {string}
     * @memberof TypingGetBestScoresResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingGetBestScoresResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingGetCharacterResponse
 */
export interface TypingGetCharacterResponse {
    /**
     * 
     * @type {Array<TypingCharacter>}
     * @memberof TypingGetCharacterResponse
     */
    'data'?: Array<TypingCharacter>;
    /**
     * Response message
     * @type {string}
     * @memberof TypingGetCharacterResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingGetCharacterResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingGetGradeResponse
 */
export interface TypingGetGradeResponse {
    /**
     * 
     * @type {Array<TypingGrade>}
     * @memberof TypingGetGradeResponse
     */
    'data': Array<TypingGrade>;
    /**
     * Response message
     * @type {string}
     * @memberof TypingGetGradeResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingGetGradeResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingGetGradesCurrentResponse
 */
export interface TypingGetGradesCurrentResponse {
    /**
     * 
     * @type {Array<TypingCurrentGrade>}
     * @memberof TypingGetGradesCurrentResponse
     */
    'data'?: Array<TypingCurrentGrade>;
    /**
     * Response message
     * @type {string}
     * @memberof TypingGetGradesCurrentResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingGetGradesCurrentResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingGetResultResponse
 */
export interface TypingGetResultResponse {
    /**
     * 
     * @type {Array<TypingResult>}
     * @memberof TypingGetResultResponse
     */
    'data': Array<TypingResult>;
    /**
     * Response message
     * @type {string}
     * @memberof TypingGetResultResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingGetResultResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingGetWordResponse
 */
export interface TypingGetWordResponse {
    /**
     * 
     * @type {Array<TypingWord>}
     * @memberof TypingGetWordResponse
     */
    'data'?: Array<TypingWord>;
    /**
     * Response message
     * @type {string}
     * @memberof TypingGetWordResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingGetWordResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingGrade
 */
export interface TypingGrade {
    /**
     * 
     * @type {string}
     * @memberof TypingGrade
     */
    'characterType': string;
    /**
     * 
     * @type {number}
     * @memberof TypingGrade
     */
    'clearScore': number;
    /**
     * 
     * @type {string}
     * @memberof TypingGrade
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof TypingGrade
     */
    'gradeNumber': number;
    /**
     * 
     * @type {number}
     * @memberof TypingGrade
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypingGrade
     */
    'limitSeconds': number;
    /**
     * 
     * @type {string}
     * @memberof TypingGrade
     */
    'themeType': TypingGradeThemeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TypingGrade
     */
    'tutorialType': TypingGradeTutorialTypeEnum;
}

export const TypingGradeThemeTypeEnum = {
    Disney: 'disney',
    Micratch: 'micratch',
    Roblox: 'roblox'
} as const;

export type TypingGradeThemeTypeEnum = typeof TypingGradeThemeTypeEnum[keyof typeof TypingGradeThemeTypeEnum];
export const TypingGradeTutorialTypeEnum = {
    None: 'none',
    Uppercase: 'uppercase',
    Space: 'space'
} as const;

export type TypingGradeTutorialTypeEnum = typeof TypingGradeTutorialTypeEnum[keyof typeof TypingGradeTutorialTypeEnum];

/**
 * 
 * @export
 * @interface TypingInsertGrade
 */
export interface TypingInsertGrade {
    /**
     * 
     * @type {number}
     * @memberof TypingInsertGrade
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TypingInsertGradeRequest
 */
export interface TypingInsertGradeRequest {
    /**
     * 
     * @type {string}
     * @memberof TypingInsertGradeRequest
     */
    'characterType': string;
    /**
     * 
     * @type {number}
     * @memberof TypingInsertGradeRequest
     */
    'clearScore': number;
    /**
     * 
     * @type {string}
     * @memberof TypingInsertGradeRequest
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof TypingInsertGradeRequest
     */
    'gradeNumber': number;
    /**
     * 
     * @type {number}
     * @memberof TypingInsertGradeRequest
     */
    'limitSeconds': number;
    /**
     * 
     * @type {string}
     * @memberof TypingInsertGradeRequest
     */
    'themeType': TypingInsertGradeRequestThemeTypeEnum;
}

export const TypingInsertGradeRequestThemeTypeEnum = {
    Disney: 'disney',
    Micratch: 'micratch',
    Roblox: 'roblox'
} as const;

export type TypingInsertGradeRequestThemeTypeEnum = typeof TypingInsertGradeRequestThemeTypeEnum[keyof typeof TypingInsertGradeRequestThemeTypeEnum];

/**
 * 
 * @export
 * @interface TypingInsertGradeResponse
 */
export interface TypingInsertGradeResponse {
    /**
     * 
     * @type {TypingInsertGradeResponseData}
     * @memberof TypingInsertGradeResponse
     */
    'data'?: TypingInsertGradeResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof TypingInsertGradeResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingInsertGradeResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingInsertGradeResponseData
 */
export interface TypingInsertGradeResponseData {
    /**
     * 
     * @type {number}
     * @memberof TypingInsertGradeResponseData
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TypingInsertResultRequest
 */
export interface TypingInsertResultRequest {
    /**
     * 
     * @type {number}
     * @memberof TypingInsertResultRequest
     */
    'correctTypeCount': number;
    /**
     * 
     * @type {number}
     * @memberof TypingInsertResultRequest
     */
    'gradeNumber': number;
    /**
     * 
     * @type {number}
     * @memberof TypingInsertResultRequest
     */
    'missTypeCount': number;
    /**
     * 
     * @type {number}
     * @memberof TypingInsertResultRequest
     */
    'score': number;
    /**
     * 
     * @type {string}
     * @memberof TypingInsertResultRequest
     */
    'themeType': TypingInsertResultRequestThemeTypeEnum;
}

export const TypingInsertResultRequestThemeTypeEnum = {
    Disney: 'disney',
    Micratch: 'micratch',
    Roblox: 'roblox'
} as const;

export type TypingInsertResultRequestThemeTypeEnum = typeof TypingInsertResultRequestThemeTypeEnum[keyof typeof TypingInsertResultRequestThemeTypeEnum];

/**
 * 
 * @export
 * @interface TypingInsertResultResponse
 */
export interface TypingInsertResultResponse {
    /**
     * 
     * @type {TypingInsertResultResponseData}
     * @memberof TypingInsertResultResponse
     */
    'data': TypingInsertResultResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof TypingInsertResultResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingInsertResultResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingInsertResultResponseData
 */
export interface TypingInsertResultResponseData {
    /**
     * 
     * @type {number}
     * @memberof TypingInsertResultResponseData
     */
    'bestScore'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypingInsertResultResponseData
     */
    'characterType': string;
    /**
     * 
     * @type {number}
     * @memberof TypingInsertResultResponseData
     */
    'clearScore': number;
    /**
     * 
     * @type {string}
     * @memberof TypingInsertResultResponseData
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof TypingInsertResultResponseData
     */
    'expPoint'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypingInsertResultResponseData
     */
    'expType'?: TypingInsertResultResponseDataExpTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof TypingInsertResultResponseData
     */
    'firstClearedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypingInsertResultResponseData
     */
    'gradeNumber': number;
    /**
     * 
     * @type {number}
     * @memberof TypingInsertResultResponseData
     */
    'limitSeconds': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof TypingInsertResultResponseData
     */
    'playedScores': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof TypingInsertResultResponseData
     */
    'themeType': TypingInsertResultResponseDataThemeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TypingInsertResultResponseData
     */
    'tutorialType': TypingInsertResultResponseDataTutorialTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof TypingInsertResultResponseData
     */
    'typingGradeId': number;
}

export const TypingInsertResultResponseDataExpTypeEnum = {
    FirstClear: 'first_clear',
    Clear: 'clear',
    Play: 'play',
    Null: 'null'
} as const;

export type TypingInsertResultResponseDataExpTypeEnum = typeof TypingInsertResultResponseDataExpTypeEnum[keyof typeof TypingInsertResultResponseDataExpTypeEnum];
export const TypingInsertResultResponseDataThemeTypeEnum = {
    Disney: 'disney',
    Micratch: 'micratch',
    Roblox: 'roblox'
} as const;

export type TypingInsertResultResponseDataThemeTypeEnum = typeof TypingInsertResultResponseDataThemeTypeEnum[keyof typeof TypingInsertResultResponseDataThemeTypeEnum];
export const TypingInsertResultResponseDataTutorialTypeEnum = {
    None: 'none',
    Uppercase: 'uppercase',
    Space: 'space'
} as const;

export type TypingInsertResultResponseDataTutorialTypeEnum = typeof TypingInsertResultResponseDataTutorialTypeEnum[keyof typeof TypingInsertResultResponseDataTutorialTypeEnum];

/**
 * 
 * @export
 * @interface TypingInsertWord
 */
export interface TypingInsertWord {
    /**
     * 
     * @type {number}
     * @memberof TypingInsertWord
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface TypingInsertWordRequest
 */
export interface TypingInsertWordRequest {
    /**
     * 
     * @type {string}
     * @memberof TypingInsertWordRequest
     */
    'displayWord': string;
    /**
     * 
     * @type {number}
     * @memberof TypingInsertWordRequest
     */
    'gradeId': number;
    /**
     * 
     * @type {string}
     * @memberof TypingInsertWordRequest
     */
    'inputWord': string;
}
/**
 * 
 * @export
 * @interface TypingInsertWordResponse
 */
export interface TypingInsertWordResponse {
    /**
     * 
     * @type {TypingInsertWord}
     * @memberof TypingInsertWordResponse
     */
    'data'?: TypingInsertWord;
    /**
     * Response message
     * @type {string}
     * @memberof TypingInsertWordResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingInsertWordResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingResult
 */
export interface TypingResult {
    /**
     * 
     * @type {number}
     * @memberof TypingResult
     */
    'bestScore'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypingResult
     */
    'characterType': string;
    /**
     * 
     * @type {number}
     * @memberof TypingResult
     */
    'clearScore': number;
    /**
     * 
     * @type {string}
     * @memberof TypingResult
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof TypingResult
     */
    'expPoint'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypingResult
     */
    'expType'?: TypingResultExpTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof TypingResult
     */
    'firstClearedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypingResult
     */
    'gradeNumber': number;
    /**
     * 
     * @type {number}
     * @memberof TypingResult
     */
    'limitSeconds': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof TypingResult
     */
    'playedScores': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof TypingResult
     */
    'themeType': TypingResultThemeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TypingResult
     */
    'tutorialType': TypingResultTutorialTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof TypingResult
     */
    'typingGradeId': number;
}

export const TypingResultExpTypeEnum = {
    FirstClear: 'first_clear',
    Clear: 'clear',
    Play: 'play',
    Null: 'null'
} as const;

export type TypingResultExpTypeEnum = typeof TypingResultExpTypeEnum[keyof typeof TypingResultExpTypeEnum];
export const TypingResultThemeTypeEnum = {
    Disney: 'disney',
    Micratch: 'micratch',
    Roblox: 'roblox'
} as const;

export type TypingResultThemeTypeEnum = typeof TypingResultThemeTypeEnum[keyof typeof TypingResultThemeTypeEnum];
export const TypingResultTutorialTypeEnum = {
    None: 'none',
    Uppercase: 'uppercase',
    Space: 'space'
} as const;

export type TypingResultTutorialTypeEnum = typeof TypingResultTutorialTypeEnum[keyof typeof TypingResultTutorialTypeEnum];

/**
 * 
 * @export
 * @interface TypingUpdateGrade
 */
export interface TypingUpdateGrade {
    /**
     * 
     * @type {number}
     * @memberof TypingUpdateGrade
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TypingUpdateGradeRequest
 */
export interface TypingUpdateGradeRequest {
    /**
     * 
     * @type {string}
     * @memberof TypingUpdateGradeRequest
     */
    'characterType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypingUpdateGradeRequest
     */
    'clearScore'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypingUpdateGradeRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypingUpdateGradeRequest
     */
    'gradeNumber': number;
    /**
     * 
     * @type {number}
     * @memberof TypingUpdateGradeRequest
     */
    'limitSeconds'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypingUpdateGradeRequest
     */
    'themeType'?: TypingUpdateGradeRequestThemeTypeEnum;
}

export const TypingUpdateGradeRequestThemeTypeEnum = {
    Disney: 'disney',
    Micratch: 'micratch',
    Roblox: 'roblox'
} as const;

export type TypingUpdateGradeRequestThemeTypeEnum = typeof TypingUpdateGradeRequestThemeTypeEnum[keyof typeof TypingUpdateGradeRequestThemeTypeEnum];

/**
 * 
 * @export
 * @interface TypingUpdateGradeResponse
 */
export interface TypingUpdateGradeResponse {
    /**
     * 
     * @type {TypingUpdateGradeResponseData}
     * @memberof TypingUpdateGradeResponse
     */
    'data'?: TypingUpdateGradeResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof TypingUpdateGradeResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingUpdateGradeResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingUpdateGradeResponseData
 */
export interface TypingUpdateGradeResponseData {
    /**
     * 
     * @type {number}
     * @memberof TypingUpdateGradeResponseData
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TypingUpdateWord
 */
export interface TypingUpdateWord {
    /**
     * 
     * @type {number}
     * @memberof TypingUpdateWord
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface TypingUpdateWordRequest
 */
export interface TypingUpdateWordRequest {
    /**
     * 
     * @type {string}
     * @memberof TypingUpdateWordRequest
     */
    'displayWord'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypingUpdateWordRequest
     */
    'inputWord'?: string | null;
}
/**
 * 
 * @export
 * @interface TypingUpdateWordResponse
 */
export interface TypingUpdateWordResponse {
    /**
     * 
     * @type {TypingUpdateWordResponseData}
     * @memberof TypingUpdateWordResponse
     */
    'data'?: TypingUpdateWordResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof TypingUpdateWordResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof TypingUpdateWordResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface TypingUpdateWordResponseData
 */
export interface TypingUpdateWordResponseData {
    /**
     * 
     * @type {number}
     * @memberof TypingUpdateWordResponseData
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface TypingWord
 */
export interface TypingWord {
    /**
     * 
     * @type {string}
     * @memberof TypingWord
     */
    'displayWord': string;
    /**
     * 
     * @type {number}
     * @memberof TypingWord
     */
    'gradeId': number;
    /**
     * 
     * @type {number}
     * @memberof TypingWord
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypingWord
     */
    'inputWord'?: string;
}
/**
 * 
 * @export
 * @interface UpdateAcquiredStatusRequest
 */
export interface UpdateAcquiredStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAcquiredStatusRequest
     */
    'rewardCode': string;
}
/**
 * 
 * @export
 * @interface UpdateAcquiredStatusResponse
 */
export interface UpdateAcquiredStatusResponse {
    /**
     * 
     * @type {UpdateAcquiredStatusResponseData}
     * @memberof UpdateAcquiredStatusResponse
     */
    'data': UpdateAcquiredStatusResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof UpdateAcquiredStatusResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof UpdateAcquiredStatusResponse
     */
    'success'?: boolean;
}
/**
 * レスポンスデータ
 * @export
 * @interface UpdateAcquiredStatusResponseData
 */
export interface UpdateAcquiredStatusResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAcquiredStatusResponseData
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface UpdateCheckedStatusRequest
 */
export interface UpdateCheckedStatusRequest {
    /**
     * User Stamp ID.
     * @type {number}
     * @memberof UpdateCheckedStatusRequest
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface UpdateCheckedStatusResponse
 */
export interface UpdateCheckedStatusResponse {
    /**
     * 
     * @type {UpdateCheckedStatusResponseData}
     * @memberof UpdateCheckedStatusResponse
     */
    'data'?: UpdateCheckedStatusResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof UpdateCheckedStatusResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof UpdateCheckedStatusResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateCheckedStatusResponseData
 */
export interface UpdateCheckedStatusResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCheckedStatusResponseData
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface UpdateStudyMissionAcquiredRequest
 */
export interface UpdateStudyMissionAcquiredRequest {
    /**
     * 更新対象のミッションID
     * @type {number}
     * @memberof UpdateStudyMissionAcquiredRequest
     */
    'missionId': number;
}
/**
 * 
 * @export
 * @interface UpdateStudyMissionAcquiredResponse
 */
export interface UpdateStudyMissionAcquiredResponse {
    /**
     * 
     * @type {UpdateStudyMissionAcquiredResponseData}
     * @memberof UpdateStudyMissionAcquiredResponse
     */
    'data'?: UpdateStudyMissionAcquiredResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof UpdateStudyMissionAcquiredResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof UpdateStudyMissionAcquiredResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateStudyMissionAcquiredResponseData
 */
export interface UpdateStudyMissionAcquiredResponseData {
    /**
     * 
     * @type {number}
     * @memberof UpdateStudyMissionAcquiredResponseData
     */
    'exp'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudyMissionAcquiredResponseData
     */
    'expDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStudyMissionAcquiredResponseData
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface UpdateUserPlanHistoryStatusRequest
 */
export interface UpdateUserPlanHistoryStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPlanHistoryStatusRequest
     */
    'newStatus': UpdateUserPlanHistoryStatusRequestNewStatusEnum;
}

export const UpdateUserPlanHistoryStatusRequestNewStatusEnum = {
    Active: 'active',
    Error: 'error',
    Cancel: 'cancel',
    Suspend: 'suspend'
} as const;

export type UpdateUserPlanHistoryStatusRequestNewStatusEnum = typeof UpdateUserPlanHistoryStatusRequestNewStatusEnum[keyof typeof UpdateUserPlanHistoryStatusRequestNewStatusEnum];

/**
 * 
 * @export
 * @interface UpdateUserPlanHistoryStatusResponse
 */
export interface UpdateUserPlanHistoryStatusResponse {
    /**
     * 
     * @type {UpdateUserPlanHistoryStatusResponseData}
     * @memberof UpdateUserPlanHistoryStatusResponse
     */
    'data': UpdateUserPlanHistoryStatusResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof UpdateUserPlanHistoryStatusResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof UpdateUserPlanHistoryStatusResponse
     */
    'success'?: boolean;
}
/**
 * Response data
 * @export
 * @interface UpdateUserPlanHistoryStatusResponseData
 */
export interface UpdateUserPlanHistoryStatusResponseData {
    /**
     * Indicates if the update was successful.
     * @type {boolean}
     * @memberof UpdateUserPlanHistoryStatusResponseData
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * User birthdate
     * @type {string}
     * @memberof User
     */
    'birthdate'?: string | null;
    /**
     * user ID
     * @type {number}
     * @memberof User
     */
    'id': number;
    /**
     * Login provider
     * @type {string}
     * @memberof User
     */
    'loginProvider'?: string | null;
    /**
     * User nickname
     * @type {string}
     * @memberof User
     */
    'nickname': string;
}
/**
 * 
 * @export
 * @interface UserActiveCoursesData
 */
export interface UserActiveCoursesData {
    /**
     * Users can take course codes
     * @type {Array<string>}
     * @memberof UserActiveCoursesData
     */
    'codes': Array<string>;
}
/**
 * 
 * @export
 * @interface UserActiveCoursesResponse
 */
export interface UserActiveCoursesResponse {
    /**
     * Users can take course information
     * @type {UserActiveCoursesData}
     * @memberof UserActiveCoursesResponse
     */
    'data': UserActiveCoursesData;
    /**
     * Response message
     * @type {string}
     * @memberof UserActiveCoursesResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof UserActiveCoursesResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface UserMissionPair
 */
export interface UserMissionPair {
    /**
     * Mission ID for this user
     * @type {number}
     * @memberof UserMissionPair
     */
    'missionId': number;
    /**
     * WordPress user ID
     * @type {number}
     * @memberof UserMissionPair
     */
    'wpUserId': number;
}
/**
 * 
 * @export
 * @interface UserMissionProgressData
 */
export interface UserMissionProgressData {
    /**
     * List of mission progress data
     * @type {Array<MissionProgressData>}
     * @memberof UserMissionProgressData
     */
    'missions': Array<MissionProgressData>;
    /**
     * Internal user ID
     * @type {number}
     * @memberof UserMissionProgressData
     */
    'userId': number;
    /**
     * WordPress user ID (only for multiple users request)
     * @type {number}
     * @memberof UserMissionProgressData
     */
    'wpUserId'?: number | null;
}
/**
 * 
 * @export
 * @interface UserSettingResponse
 */
export interface UserSettingResponse {
    /**
     * 
     * @type {UserSettingResponseData}
     * @memberof UserSettingResponse
     */
    'data'?: UserSettingResponseData;
    /**
     * Response message
     * @type {string}
     * @memberof UserSettingResponse
     */
    'message'?: string;
    /**
     * Success status
     * @type {boolean}
     * @memberof UserSettingResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface UserSettingResponseData
 */
export interface UserSettingResponseData {
    /**
     * 
     * @type {StudyCourseData}
     * @memberof UserSettingResponseData
     */
    'studyCourse'?: StudyCourseData;
    /**
     * デジタネひろばの表示/非表示
     * @type {boolean}
     * @memberof UserSettingResponseData
     */
    'useChat': boolean;
    /**
     * ユーザーアイコンURL
     * @type {string}
     * @memberof UserSettingResponseData
     */
    'userIconUrl': string;
}
/**
 * 
 * @export
 * @interface UserSettingUpdateRequest
 */
export interface UserSettingUpdateRequest {
    /**
     * 学習コースID
     * @type {number}
     * @memberof UserSettingUpdateRequest
     */
    'studyCourseId'?: number | null;
    /**
     * デジタネひろばの表示/非表示
     * @type {boolean}
     * @memberof UserSettingUpdateRequest
     */
    'useChat'?: boolean | null;
    /**
     * ユーザーアイコンURL
     * @type {string}
     * @memberof UserSettingUpdateRequest
     */
    'userIconUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface UserStampData
 */
export interface UserStampData {
    /**
     * 
     * @type {string}
     * @memberof UserStampData
     */
    'createdAt': string;
    /**
     * User Stamp ID.
     * @type {number}
     * @memberof UserStampData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserStampData
     */
    'imgPath'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserStampData
     */
    'isChecked': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserStampData
     */
    'message'?: string;
    /**
     * Stamp ID.
     * @type {number}
     * @memberof UserStampData
     */
    'stampId': number;
    /**
     * 
     * @type {string}
     * @memberof UserStampData
     */
    'stampType': string;
}
/**
 * User type identifier
 * @export
 * @enum {string}
 */

export const UserType = {
    Administrator: 'administrator',
    Author: 'author',
    Subscriber: 'subscriber',
    Anax: 'anax',
    Comotto: 'comotto',
    Itscom: 'itscom',
    ClassroomManager: 'classroom_manager'
} as const;

export type UserType = typeof UserType[keyof typeof UserType];



/**
 * AlbApi - axios parameter creator
 * @export
 */
export const AlbApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAlbHealthCheckGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alb/health_check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlbApi - functional programming interface
 * @export
 */
export const AlbApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlbApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAlbHealthCheckGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Error>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAlbHealthCheckGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlbApi.apiAlbHealthCheckGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AlbApi - factory interface
 * @export
 */
export const AlbApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlbApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAlbHealthCheckGet(options?: RawAxiosRequestConfig): AxiosPromise<Error> {
            return localVarFp.apiAlbHealthCheckGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlbApi - object-oriented interface
 * @export
 * @class AlbApi
 * @extends {BaseAPI}
 */
export class AlbApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlbApi
     */
    public apiAlbHealthCheckGet(options?: RawAxiosRequestConfig) {
        return AlbApiFp(this.configuration).apiAlbHealthCheckGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Google Login API
         * @param {LoginGoogleRequest} loginGoogleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthLoginGooglePost: async (loginGoogleRequest: LoginGoogleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginGoogleRequest' is not null or undefined
            assertParamExists('apiV1AuthLoginGooglePost', 'loginGoogleRequest', loginGoogleRequest)
            const localVarPath = `/api/v1/auth/login/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginGoogleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login API
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthLoginPost: async (loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('apiV1AuthLoginPost', 'loginRequest', loginRequest)
            const localVarPath = `/api/v1/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthLogoutPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Google Login API
         * @param {LoginGoogleRequest} loginGoogleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AuthLoginGooglePost(loginGoogleRequest: LoginGoogleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthLoginGooglePost(loginGoogleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AuthLoginGooglePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login API
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AuthLoginPost(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthLoginPost(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AuthLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logout API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AuthLogoutPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogoutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthLogoutPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AuthLogoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Google Login API
         * @param {LoginGoogleRequest} loginGoogleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthLoginGooglePost(loginGoogleRequest: LoginGoogleRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.apiV1AuthLoginGooglePost(loginGoogleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login API
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthLoginPost(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.apiV1AuthLoginPost(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthLogoutPost(options?: RawAxiosRequestConfig): AxiosPromise<LogoutResponse> {
            return localVarFp.apiV1AuthLogoutPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Google Login API
     * @param {LoginGoogleRequest} loginGoogleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiV1AuthLoginGooglePost(loginGoogleRequest: LoginGoogleRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AuthLoginGooglePost(loginGoogleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login API
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiV1AuthLoginPost(loginRequest: LoginRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AuthLoginPost(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiV1AuthLogoutPost(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AuthLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChapterApi - axios parameter creator
 * @export
 */
export const ChapterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch selected chapter
         * @param {ApiV1ChaptersGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {string} stageCode stage code
         * @param {number} missionSeq mission seq
         * @param {number} chapterSeq chapter seq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChaptersGet: async (siteName: ApiV1ChaptersGetSiteNameEnum, stageCode: string, missionSeq: number, chapterSeq: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteName' is not null or undefined
            assertParamExists('apiV1ChaptersGet', 'siteName', siteName)
            // verify required parameter 'stageCode' is not null or undefined
            assertParamExists('apiV1ChaptersGet', 'stageCode', stageCode)
            // verify required parameter 'missionSeq' is not null or undefined
            assertParamExists('apiV1ChaptersGet', 'missionSeq', missionSeq)
            // verify required parameter 'chapterSeq' is not null or undefined
            assertParamExists('apiV1ChaptersGet', 'chapterSeq', chapterSeq)
            const localVarPath = `/api/v1/chapters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (siteName !== undefined) {
                localVarQueryParameter['site_name'] = siteName;
            }

            if (stageCode !== undefined) {
                localVarQueryParameter['stage_code'] = stageCode;
            }

            if (missionSeq !== undefined) {
                localVarQueryParameter['mission_seq'] = missionSeq;
            }

            if (chapterSeq !== undefined) {
                localVarQueryParameter['chapter_seq'] = chapterSeq;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [GET] ユーザーの全チャプター結果（chapter_id）を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChaptersResultsAllGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chapters/results/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クエリパラメータ:     - mission_id: 対象ミッションのID  Returns:     ChapterListResponse: レスポンス
         * @summary [GET] ミッションIDに基づいて章結果を取得する API
         * @param {ApiV1ChaptersResultsGetSiteNameEnum} [siteName] Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {number | null} [missionId] mission id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChaptersResultsGet: async (siteName?: ApiV1ChaptersResultsGetSiteNameEnum, missionId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chapters/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (siteName !== undefined) {
                localVarQueryParameter['site_name'] = siteName;
            }

            if (missionId !== undefined) {
                localVarQueryParameter['mission_id'] = missionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * JSON ペイロード:     - chapter_id: 投稿対象の章ID  Returns:     PostChapterResultResponse: チャプター、ミッション、リワード、経験値の情報
         * @summary [POST] チャプタークリアAPI
         * @param {PostChapterResultRequest} postChapterResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChaptersResultsPost: async (postChapterResultRequest: PostChapterResultRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postChapterResultRequest' is not null or undefined
            assertParamExists('apiV1ChaptersResultsPost', 'postChapterResultRequest', postChapterResultRequest)
            const localVarPath = `/api/v1/chapters/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postChapterResultRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChapterApi - functional programming interface
 * @export
 */
export const ChapterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChapterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Fetch selected chapter
         * @param {ApiV1ChaptersGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {string} stageCode stage code
         * @param {number} missionSeq mission seq
         * @param {number} chapterSeq chapter seq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChaptersGet(siteName: ApiV1ChaptersGetSiteNameEnum, stageCode: string, missionSeq: number, chapterSeq: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChapterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChaptersGet(siteName, stageCode, missionSeq, chapterSeq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChapterApi.apiV1ChaptersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [GET] ユーザーの全チャプター結果（chapter_id）を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChaptersResultsAllGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllChapterResultsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChaptersResultsAllGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChapterApi.apiV1ChaptersResultsAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * クエリパラメータ:     - mission_id: 対象ミッションのID  Returns:     ChapterListResponse: レスポンス
         * @summary [GET] ミッションIDに基づいて章結果を取得する API
         * @param {ApiV1ChaptersResultsGetSiteNameEnum} [siteName] Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {number | null} [missionId] mission id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChaptersResultsGet(siteName?: ApiV1ChaptersResultsGetSiteNameEnum, missionId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChapterListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChaptersResultsGet(siteName, missionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChapterApi.apiV1ChaptersResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * JSON ペイロード:     - chapter_id: 投稿対象の章ID  Returns:     PostChapterResultResponse: チャプター、ミッション、リワード、経験値の情報
         * @summary [POST] チャプタークリアAPI
         * @param {PostChapterResultRequest} postChapterResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChaptersResultsPost(postChapterResultRequest: PostChapterResultRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostChapterResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChaptersResultsPost(postChapterResultRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChapterApi.apiV1ChaptersResultsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChapterApi - factory interface
 * @export
 */
export const ChapterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChapterApiFp(configuration)
    return {
        /**
         * 
         * @summary Fetch selected chapter
         * @param {ApiV1ChaptersGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {string} stageCode stage code
         * @param {number} missionSeq mission seq
         * @param {number} chapterSeq chapter seq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChaptersGet(siteName: ApiV1ChaptersGetSiteNameEnum, stageCode: string, missionSeq: number, chapterSeq: number, options?: RawAxiosRequestConfig): AxiosPromise<ChapterResponse> {
            return localVarFp.apiV1ChaptersGet(siteName, stageCode, missionSeq, chapterSeq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [GET] ユーザーの全チャプター結果（chapter_id）を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChaptersResultsAllGet(options?: RawAxiosRequestConfig): AxiosPromise<GetAllChapterResultsResponse> {
            return localVarFp.apiV1ChaptersResultsAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * クエリパラメータ:     - mission_id: 対象ミッションのID  Returns:     ChapterListResponse: レスポンス
         * @summary [GET] ミッションIDに基づいて章結果を取得する API
         * @param {ApiV1ChaptersResultsGetSiteNameEnum} [siteName] Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {number | null} [missionId] mission id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChaptersResultsGet(siteName?: ApiV1ChaptersResultsGetSiteNameEnum, missionId?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<ChapterListResponse> {
            return localVarFp.apiV1ChaptersResultsGet(siteName, missionId, options).then((request) => request(axios, basePath));
        },
        /**
         * JSON ペイロード:     - chapter_id: 投稿対象の章ID  Returns:     PostChapterResultResponse: チャプター、ミッション、リワード、経験値の情報
         * @summary [POST] チャプタークリアAPI
         * @param {PostChapterResultRequest} postChapterResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChaptersResultsPost(postChapterResultRequest: PostChapterResultRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostChapterResultResponse> {
            return localVarFp.apiV1ChaptersResultsPost(postChapterResultRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChapterApi - object-oriented interface
 * @export
 * @class ChapterApi
 * @extends {BaseAPI}
 */
export class ChapterApi extends BaseAPI {
    /**
     * 
     * @summary Fetch selected chapter
     * @param {ApiV1ChaptersGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
     * @param {string} stageCode stage code
     * @param {number} missionSeq mission seq
     * @param {number} chapterSeq chapter seq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChapterApi
     */
    public apiV1ChaptersGet(siteName: ApiV1ChaptersGetSiteNameEnum, stageCode: string, missionSeq: number, chapterSeq: number, options?: RawAxiosRequestConfig) {
        return ChapterApiFp(this.configuration).apiV1ChaptersGet(siteName, stageCode, missionSeq, chapterSeq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [GET] ユーザーの全チャプター結果（chapter_id）を取得する API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChapterApi
     */
    public apiV1ChaptersResultsAllGet(options?: RawAxiosRequestConfig) {
        return ChapterApiFp(this.configuration).apiV1ChaptersResultsAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クエリパラメータ:     - mission_id: 対象ミッションのID  Returns:     ChapterListResponse: レスポンス
     * @summary [GET] ミッションIDに基づいて章結果を取得する API
     * @param {ApiV1ChaptersResultsGetSiteNameEnum} [siteName] Site name, either \&#39;online\&#39; or \&#39;license\&#39;
     * @param {number | null} [missionId] mission id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChapterApi
     */
    public apiV1ChaptersResultsGet(siteName?: ApiV1ChaptersResultsGetSiteNameEnum, missionId?: number | null, options?: RawAxiosRequestConfig) {
        return ChapterApiFp(this.configuration).apiV1ChaptersResultsGet(siteName, missionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * JSON ペイロード:     - chapter_id: 投稿対象の章ID  Returns:     PostChapterResultResponse: チャプター、ミッション、リワード、経験値の情報
     * @summary [POST] チャプタークリアAPI
     * @param {PostChapterResultRequest} postChapterResultRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChapterApi
     */
    public apiV1ChaptersResultsPost(postChapterResultRequest: PostChapterResultRequest, options?: RawAxiosRequestConfig) {
        return ChapterApiFp(this.configuration).apiV1ChaptersResultsPost(postChapterResultRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiV1ChaptersGetSiteNameEnum = {
    Online: 'online',
    License: 'license'
} as const;
export type ApiV1ChaptersGetSiteNameEnum = typeof ApiV1ChaptersGetSiteNameEnum[keyof typeof ApiV1ChaptersGetSiteNameEnum];
/**
 * @export
 */
export const ApiV1ChaptersResultsGetSiteNameEnum = {
    Online: 'online',
    License: 'license',
    Null: 'null'
} as const;
export type ApiV1ChaptersResultsGetSiteNameEnum = typeof ApiV1ChaptersResultsGetSiteNameEnum[keyof typeof ApiV1ChaptersResultsGetSiteNameEnum];


/**
 * CommunityApi - axios parameter creator
 * @export
 */
export const CommunityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary コミュニティキャラクター一覧取得API ログイン不要。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityCharactersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/community/characters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 自分がキャラクターかチェックAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityCharactersMeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/community/characters/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コミュニティイベント一覧取得API ログイン不要。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityEventsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/community/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コミュニティプロジェクト一覧取得API ログイン不要。ただし、ログインしている場合はliked_by_meとplayed_by_meが取得可能。
         * @param {ApiV1CommunityProjectsGetLangEnum} [lang] 
         * @param {string | null} [search] 
         * @param {number | null} [eventId] 
         * @param {number | null} [authorId] 
         * @param {boolean} [likedByUser] 
         * @param {ApiV1CommunityProjectsGetSortByEnum} [sortBy] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsGet: async (lang?: ApiV1CommunityProjectsGetLangEnum, search?: string | null, eventId?: number | null, authorId?: number | null, likedByUser?: boolean, sortBy?: ApiV1CommunityProjectsGetSortByEnum, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/community/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (eventId !== undefined) {
                localVarQueryParameter['event_id'] = eventId;
            }

            if (authorId !== undefined) {
                localVarQueryParameter['author_id'] = authorId;
            }

            if (likedByUser !== undefined) {
                localVarQueryParameter['liked_by_user'] = likedByUser;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コミュニティプロジェクト作成API
         * @param {CommunityProjectCreateRequest} communityProjectCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsPost: async (communityProjectCreateRequest: CommunityProjectCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityProjectCreateRequest' is not null or undefined
            assertParamExists('apiV1CommunityProjectsPost', 'communityProjectCreateRequest', communityProjectCreateRequest)
            const localVarPath = `/api/v1/community/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communityProjectCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コミュニティプロジェクトコメント削除API (所有者のみ)
         * @param {number} projectId 
         * @param {number} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdCommentsCommentIdDelete: async (projectId: number, commentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiV1CommunityProjectsProjectIdCommentsCommentIdDelete', 'projectId', projectId)
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('apiV1CommunityProjectsProjectIdCommentsCommentIdDelete', 'commentId', commentId)
            const localVarPath = `/api/v1/community/projects/{project_id}/comments/{comment_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"comment_id"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コミュニティプロジェクトコメント一覧取得API ログイン不要。
         * @param {number} projectId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdCommentsGet: async (projectId: number, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiV1CommunityProjectsProjectIdCommentsGet', 'projectId', projectId)
            const localVarPath = `/api/v1/community/projects/{project_id}/comments`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コミュニティプロジェクトコメント作成API (キャラクターのみ)
         * @param {number} projectId 
         * @param {CommunityCommentCreateRequest} communityCommentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdCommentsPost: async (projectId: number, communityCommentCreateRequest: CommunityCommentCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiV1CommunityProjectsProjectIdCommentsPost', 'projectId', projectId)
            // verify required parameter 'communityCommentCreateRequest' is not null or undefined
            assertParamExists('apiV1CommunityProjectsProjectIdCommentsPost', 'communityCommentCreateRequest', communityCommentCreateRequest)
            const localVarPath = `/api/v1/community/projects/{project_id}/comments`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communityCommentCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コミュニティプロジェクト削除API (オーナーのみ)
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdDelete: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiV1CommunityProjectsProjectIdDelete', 'projectId', projectId)
            const localVarPath = `/api/v1/community/projects/{project_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コミュニティプロジェクト詳細取得API ログイン不要。ただし、ログインしている場合はliked_by_meとplayed_by_meが取得可能。
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdGet: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiV1CommunityProjectsProjectIdGet', 'projectId', projectId)
            const localVarPath = `/api/v1/community/projects/{project_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コミュニティプロジェクトいいねトグルAPI
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdLikePost: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiV1CommunityProjectsProjectIdLikePost', 'projectId', projectId)
            const localVarPath = `/api/v1/community/projects/{project_id}/like`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コミュニティプロジェクト更新API (オーナーのみ)
         * @param {number} projectId 
         * @param {CommunityProjectUpdateRequest} communityProjectUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdPatch: async (projectId: number, communityProjectUpdateRequest: CommunityProjectUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiV1CommunityProjectsProjectIdPatch', 'projectId', projectId)
            // verify required parameter 'communityProjectUpdateRequest' is not null or undefined
            assertParamExists('apiV1CommunityProjectsProjectIdPatch', 'communityProjectUpdateRequest', communityProjectUpdateRequest)
            const localVarPath = `/api/v1/community/projects/{project_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communityProjectUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コミュニティプロジェクト再生記録API
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdPlayPost: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiV1CommunityProjectsProjectIdPlayPost', 'projectId', projectId)
            const localVarPath = `/api/v1/community/projects/{project_id}/play`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommunityApi - functional programming interface
 * @export
 */
export const CommunityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommunityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary コミュニティキャラクター一覧取得API ログイン不要。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityCharactersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityCharacterListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityCharactersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityCharactersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 自分がキャラクターかチェックAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityCharactersMeGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityCharacterMeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityCharactersMeGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityCharactersMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コミュニティイベント一覧取得API ログイン不要。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityEventsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityEventListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityEventsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コミュニティプロジェクト一覧取得API ログイン不要。ただし、ログインしている場合はliked_by_meとplayed_by_meが取得可能。
         * @param {ApiV1CommunityProjectsGetLangEnum} [lang] 
         * @param {string | null} [search] 
         * @param {number | null} [eventId] 
         * @param {number | null} [authorId] 
         * @param {boolean} [likedByUser] 
         * @param {ApiV1CommunityProjectsGetSortByEnum} [sortBy] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityProjectsGet(lang?: ApiV1CommunityProjectsGetLangEnum, search?: string | null, eventId?: number | null, authorId?: number | null, likedByUser?: boolean, sortBy?: ApiV1CommunityProjectsGetSortByEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityProjectListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityProjectsGet(lang, search, eventId, authorId, likedByUser, sortBy, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityProjectsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コミュニティプロジェクト作成API
         * @param {CommunityProjectCreateRequest} communityProjectCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityProjectsPost(communityProjectCreateRequest: CommunityProjectCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityProjectCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityProjectsPost(communityProjectCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityProjectsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コミュニティプロジェクトコメント削除API (所有者のみ)
         * @param {number} projectId 
         * @param {number} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityProjectsProjectIdCommentsCommentIdDelete(projectId: number, commentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityCommentDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityProjectsProjectIdCommentsCommentIdDelete(projectId, commentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityProjectsProjectIdCommentsCommentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コミュニティプロジェクトコメント一覧取得API ログイン不要。
         * @param {number} projectId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityProjectsProjectIdCommentsGet(projectId: number, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityCommentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityProjectsProjectIdCommentsGet(projectId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityProjectsProjectIdCommentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コミュニティプロジェクトコメント作成API (キャラクターのみ)
         * @param {number} projectId 
         * @param {CommunityCommentCreateRequest} communityCommentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityProjectsProjectIdCommentsPost(projectId: number, communityCommentCreateRequest: CommunityCommentCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityCommentCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityProjectsProjectIdCommentsPost(projectId, communityCommentCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityProjectsProjectIdCommentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コミュニティプロジェクト削除API (オーナーのみ)
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityProjectsProjectIdDelete(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityProjectDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityProjectsProjectIdDelete(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityProjectsProjectIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コミュニティプロジェクト詳細取得API ログイン不要。ただし、ログインしている場合はliked_by_meとplayed_by_meが取得可能。
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityProjectsProjectIdGet(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityProjectDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityProjectsProjectIdGet(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityProjectsProjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コミュニティプロジェクトいいねトグルAPI
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityProjectsProjectIdLikePost(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityProjectLikeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityProjectsProjectIdLikePost(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityProjectsProjectIdLikePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コミュニティプロジェクト更新API (オーナーのみ)
         * @param {number} projectId 
         * @param {CommunityProjectUpdateRequest} communityProjectUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityProjectsProjectIdPatch(projectId: number, communityProjectUpdateRequest: CommunityProjectUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityProjectUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityProjectsProjectIdPatch(projectId, communityProjectUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityProjectsProjectIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コミュニティプロジェクト再生記録API
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunityProjectsProjectIdPlayPost(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityProjectPlayResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunityProjectsProjectIdPlayPost(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiV1CommunityProjectsProjectIdPlayPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommunityApi - factory interface
 * @export
 */
export const CommunityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommunityApiFp(configuration)
    return {
        /**
         * 
         * @summary コミュニティキャラクター一覧取得API ログイン不要。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityCharactersGet(options?: RawAxiosRequestConfig): AxiosPromise<CommunityCharacterListResponse> {
            return localVarFp.apiV1CommunityCharactersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 自分がキャラクターかチェックAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityCharactersMeGet(options?: RawAxiosRequestConfig): AxiosPromise<CommunityCharacterMeResponse> {
            return localVarFp.apiV1CommunityCharactersMeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コミュニティイベント一覧取得API ログイン不要。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityEventsGet(options?: RawAxiosRequestConfig): AxiosPromise<CommunityEventListResponse> {
            return localVarFp.apiV1CommunityEventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コミュニティプロジェクト一覧取得API ログイン不要。ただし、ログインしている場合はliked_by_meとplayed_by_meが取得可能。
         * @param {ApiV1CommunityProjectsGetLangEnum} [lang] 
         * @param {string | null} [search] 
         * @param {number | null} [eventId] 
         * @param {number | null} [authorId] 
         * @param {boolean} [likedByUser] 
         * @param {ApiV1CommunityProjectsGetSortByEnum} [sortBy] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsGet(lang?: ApiV1CommunityProjectsGetLangEnum, search?: string | null, eventId?: number | null, authorId?: number | null, likedByUser?: boolean, sortBy?: ApiV1CommunityProjectsGetSortByEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<CommunityProjectListResponse> {
            return localVarFp.apiV1CommunityProjectsGet(lang, search, eventId, authorId, likedByUser, sortBy, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コミュニティプロジェクト作成API
         * @param {CommunityProjectCreateRequest} communityProjectCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsPost(communityProjectCreateRequest: CommunityProjectCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityProjectCreateResponse> {
            return localVarFp.apiV1CommunityProjectsPost(communityProjectCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コミュニティプロジェクトコメント削除API (所有者のみ)
         * @param {number} projectId 
         * @param {number} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdCommentsCommentIdDelete(projectId: number, commentId: number, options?: RawAxiosRequestConfig): AxiosPromise<CommunityCommentDeleteResponse> {
            return localVarFp.apiV1CommunityProjectsProjectIdCommentsCommentIdDelete(projectId, commentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コミュニティプロジェクトコメント一覧取得API ログイン不要。
         * @param {number} projectId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdCommentsGet(projectId: number, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<CommunityCommentListResponse> {
            return localVarFp.apiV1CommunityProjectsProjectIdCommentsGet(projectId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コミュニティプロジェクトコメント作成API (キャラクターのみ)
         * @param {number} projectId 
         * @param {CommunityCommentCreateRequest} communityCommentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdCommentsPost(projectId: number, communityCommentCreateRequest: CommunityCommentCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityCommentCreateResponse> {
            return localVarFp.apiV1CommunityProjectsProjectIdCommentsPost(projectId, communityCommentCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コミュニティプロジェクト削除API (オーナーのみ)
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdDelete(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<CommunityProjectDeleteResponse> {
            return localVarFp.apiV1CommunityProjectsProjectIdDelete(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コミュニティプロジェクト詳細取得API ログイン不要。ただし、ログインしている場合はliked_by_meとplayed_by_meが取得可能。
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdGet(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<CommunityProjectDetailResponse> {
            return localVarFp.apiV1CommunityProjectsProjectIdGet(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コミュニティプロジェクトいいねトグルAPI
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdLikePost(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<CommunityProjectLikeResponse> {
            return localVarFp.apiV1CommunityProjectsProjectIdLikePost(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コミュニティプロジェクト更新API (オーナーのみ)
         * @param {number} projectId 
         * @param {CommunityProjectUpdateRequest} communityProjectUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdPatch(projectId: number, communityProjectUpdateRequest: CommunityProjectUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityProjectUpdateResponse> {
            return localVarFp.apiV1CommunityProjectsProjectIdPatch(projectId, communityProjectUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コミュニティプロジェクト再生記録API
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunityProjectsProjectIdPlayPost(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<CommunityProjectPlayResponse> {
            return localVarFp.apiV1CommunityProjectsProjectIdPlayPost(projectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommunityApi - object-oriented interface
 * @export
 * @class CommunityApi
 * @extends {BaseAPI}
 */
export class CommunityApi extends BaseAPI {
    /**
     * 
     * @summary コミュニティキャラクター一覧取得API ログイン不要。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityCharactersGet(options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityCharactersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 自分がキャラクターかチェックAPI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityCharactersMeGet(options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityCharactersMeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コミュニティイベント一覧取得API ログイン不要。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityEventsGet(options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityEventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コミュニティプロジェクト一覧取得API ログイン不要。ただし、ログインしている場合はliked_by_meとplayed_by_meが取得可能。
     * @param {ApiV1CommunityProjectsGetLangEnum} [lang] 
     * @param {string | null} [search] 
     * @param {number | null} [eventId] 
     * @param {number | null} [authorId] 
     * @param {boolean} [likedByUser] 
     * @param {ApiV1CommunityProjectsGetSortByEnum} [sortBy] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityProjectsGet(lang?: ApiV1CommunityProjectsGetLangEnum, search?: string | null, eventId?: number | null, authorId?: number | null, likedByUser?: boolean, sortBy?: ApiV1CommunityProjectsGetSortByEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityProjectsGet(lang, search, eventId, authorId, likedByUser, sortBy, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コミュニティプロジェクト作成API
     * @param {CommunityProjectCreateRequest} communityProjectCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityProjectsPost(communityProjectCreateRequest: CommunityProjectCreateRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityProjectsPost(communityProjectCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コミュニティプロジェクトコメント削除API (所有者のみ)
     * @param {number} projectId 
     * @param {number} commentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityProjectsProjectIdCommentsCommentIdDelete(projectId: number, commentId: number, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityProjectsProjectIdCommentsCommentIdDelete(projectId, commentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コミュニティプロジェクトコメント一覧取得API ログイン不要。
     * @param {number} projectId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityProjectsProjectIdCommentsGet(projectId: number, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityProjectsProjectIdCommentsGet(projectId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コミュニティプロジェクトコメント作成API (キャラクターのみ)
     * @param {number} projectId 
     * @param {CommunityCommentCreateRequest} communityCommentCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityProjectsProjectIdCommentsPost(projectId: number, communityCommentCreateRequest: CommunityCommentCreateRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityProjectsProjectIdCommentsPost(projectId, communityCommentCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コミュニティプロジェクト削除API (オーナーのみ)
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityProjectsProjectIdDelete(projectId: number, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityProjectsProjectIdDelete(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コミュニティプロジェクト詳細取得API ログイン不要。ただし、ログインしている場合はliked_by_meとplayed_by_meが取得可能。
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityProjectsProjectIdGet(projectId: number, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityProjectsProjectIdGet(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コミュニティプロジェクトいいねトグルAPI
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityProjectsProjectIdLikePost(projectId: number, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityProjectsProjectIdLikePost(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コミュニティプロジェクト更新API (オーナーのみ)
     * @param {number} projectId 
     * @param {CommunityProjectUpdateRequest} communityProjectUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityProjectsProjectIdPatch(projectId: number, communityProjectUpdateRequest: CommunityProjectUpdateRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityProjectsProjectIdPatch(projectId, communityProjectUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コミュニティプロジェクト再生記録API
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiV1CommunityProjectsProjectIdPlayPost(projectId: number, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiV1CommunityProjectsProjectIdPlayPost(projectId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiV1CommunityProjectsGetLangEnum = {
    Scratch: 'scratch',
    Micratch: 'micratch',
    Micratch2: 'micratch2',
    Roblox: 'roblox',
    Javascript: 'javascript',
    HtmlCss: 'html_css',
    AppInventor: 'app_inventor',
    Null: 'null'
} as const;
export type ApiV1CommunityProjectsGetLangEnum = typeof ApiV1CommunityProjectsGetLangEnum[keyof typeof ApiV1CommunityProjectsGetLangEnum];
/**
 * @export
 */
export const ApiV1CommunityProjectsGetSortByEnum = {
    Latest: 'latest',
    Popular: 'popular'
} as const;
export type ApiV1CommunityProjectsGetSortByEnum = typeof ApiV1CommunityProjectsGetSortByEnum[keyof typeof ApiV1CommunityProjectsGetSortByEnum];


/**
 * CourseApi - axios parameter creator
 * @export
 */
export const CourseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * パラメータ: - codes: コースコードのリスト（必須） - site_names: サイト名のリスト（オプション） - stage_codes: ステージコードのリスト（オプション） - only_valid: 有効なレコードのみ取得（デフォルト: true）
         * @summary コースの詳細情報を複数取得します
         * @param {Array<string>} codes List of course codes (required)
         * @param {ApiV1CoursesDetailsGetSiteNamesEnum} [siteNames] List of site names, either \&#39;online\&#39; or \&#39;license\&#39; (defaults to empty list)
         * @param {Array<string>} [stageCodes] List of stage codes (defaults to empty list)
         * @param {boolean} [onlyValid] If true, only return valid records based on valid_from/valid_to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoursesDetailsGet: async (codes: Array<string>, siteNames?: ApiV1CoursesDetailsGetSiteNamesEnum, stageCodes?: Array<string>, onlyValid?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codes' is not null or undefined
            assertParamExists('apiV1CoursesDetailsGet', 'codes', codes)
            const localVarPath = `/api/v1/courses/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (codes) {
                localVarQueryParameter['codes'] = codes;
            }

            if (siteNames) {
                localVarQueryParameter['site_names'] = siteNames;
            }

            if (stageCodes) {
                localVarQueryParameter['stage_codes'] = stageCodes;
            }

            if (onlyValid !== undefined) {
                localVarQueryParameter['only_valid'] = onlyValid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary サイトに属するすべてのコースを取得します site_nameはスキーマで必須バリデーション済み
         * @param {ApiV1CoursesGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39; (required)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoursesGet: async (siteName: ApiV1CoursesGetSiteNameEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteName' is not null or undefined
            assertParamExists('apiV1CoursesGet', 'siteName', siteName)
            const localVarPath = `/api/v1/courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (siteName !== undefined) {
                localVarQueryParameter['site_name'] = siteName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CourseApi - functional programming interface
 * @export
 */
export const CourseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CourseApiAxiosParamCreator(configuration)
    return {
        /**
         * パラメータ: - codes: コースコードのリスト（必須） - site_names: サイト名のリスト（オプション） - stage_codes: ステージコードのリスト（オプション） - only_valid: 有効なレコードのみ取得（デフォルト: true）
         * @summary コースの詳細情報を複数取得します
         * @param {Array<string>} codes List of course codes (required)
         * @param {ApiV1CoursesDetailsGetSiteNamesEnum} [siteNames] List of site names, either \&#39;online\&#39; or \&#39;license\&#39; (defaults to empty list)
         * @param {Array<string>} [stageCodes] List of stage codes (defaults to empty list)
         * @param {boolean} [onlyValid] If true, only return valid records based on valid_from/valid_to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoursesDetailsGet(codes: Array<string>, siteNames?: ApiV1CoursesDetailsGetSiteNamesEnum, stageCodes?: Array<string>, onlyValid?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseDetailsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoursesDetailsGet(codes, siteNames, stageCodes, onlyValid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseApi.apiV1CoursesDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary サイトに属するすべてのコースを取得します site_nameはスキーマで必須バリデーション済み
         * @param {ApiV1CoursesGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39; (required)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoursesGet(siteName: ApiV1CoursesGetSiteNameEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoursesGet(siteName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseApi.apiV1CoursesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CourseApi - factory interface
 * @export
 */
export const CourseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CourseApiFp(configuration)
    return {
        /**
         * パラメータ: - codes: コースコードのリスト（必須） - site_names: サイト名のリスト（オプション） - stage_codes: ステージコードのリスト（オプション） - only_valid: 有効なレコードのみ取得（デフォルト: true）
         * @summary コースの詳細情報を複数取得します
         * @param {Array<string>} codes List of course codes (required)
         * @param {ApiV1CoursesDetailsGetSiteNamesEnum} [siteNames] List of site names, either \&#39;online\&#39; or \&#39;license\&#39; (defaults to empty list)
         * @param {Array<string>} [stageCodes] List of stage codes (defaults to empty list)
         * @param {boolean} [onlyValid] If true, only return valid records based on valid_from/valid_to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoursesDetailsGet(codes: Array<string>, siteNames?: ApiV1CoursesDetailsGetSiteNamesEnum, stageCodes?: Array<string>, onlyValid?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<CourseDetailsListResponse> {
            return localVarFp.apiV1CoursesDetailsGet(codes, siteNames, stageCodes, onlyValid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary サイトに属するすべてのコースを取得します site_nameはスキーマで必須バリデーション済み
         * @param {ApiV1CoursesGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39; (required)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoursesGet(siteName: ApiV1CoursesGetSiteNameEnum, options?: RawAxiosRequestConfig): AxiosPromise<CourseListResponse> {
            return localVarFp.apiV1CoursesGet(siteName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CourseApi - object-oriented interface
 * @export
 * @class CourseApi
 * @extends {BaseAPI}
 */
export class CourseApi extends BaseAPI {
    /**
     * パラメータ: - codes: コースコードのリスト（必須） - site_names: サイト名のリスト（オプション） - stage_codes: ステージコードのリスト（オプション） - only_valid: 有効なレコードのみ取得（デフォルト: true）
     * @summary コースの詳細情報を複数取得します
     * @param {Array<string>} codes List of course codes (required)
     * @param {ApiV1CoursesDetailsGetSiteNamesEnum} [siteNames] List of site names, either \&#39;online\&#39; or \&#39;license\&#39; (defaults to empty list)
     * @param {Array<string>} [stageCodes] List of stage codes (defaults to empty list)
     * @param {boolean} [onlyValid] If true, only return valid records based on valid_from/valid_to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseApi
     */
    public apiV1CoursesDetailsGet(codes: Array<string>, siteNames?: ApiV1CoursesDetailsGetSiteNamesEnum, stageCodes?: Array<string>, onlyValid?: boolean, options?: RawAxiosRequestConfig) {
        return CourseApiFp(this.configuration).apiV1CoursesDetailsGet(codes, siteNames, stageCodes, onlyValid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary サイトに属するすべてのコースを取得します site_nameはスキーマで必須バリデーション済み
     * @param {ApiV1CoursesGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39; (required)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseApi
     */
    public apiV1CoursesGet(siteName: ApiV1CoursesGetSiteNameEnum, options?: RawAxiosRequestConfig) {
        return CourseApiFp(this.configuration).apiV1CoursesGet(siteName, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiV1CoursesDetailsGetSiteNamesEnum = {
} as const;
export type ApiV1CoursesDetailsGetSiteNamesEnum = typeof ApiV1CoursesDetailsGetSiteNamesEnum[keyof typeof ApiV1CoursesDetailsGetSiteNamesEnum];
/**
 * @export
 */
export const ApiV1CoursesGetSiteNameEnum = {
    Online: 'online',
    License: 'license'
} as const;
export type ApiV1CoursesGetSiteNameEnum = typeof ApiV1CoursesGetSiteNameEnum[keyof typeof ApiV1CoursesGetSiteNameEnum];


/**
 * EventApi - axios parameter creator
 * @export
 */
export const EventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Event Entries
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EventsEventIdEntriesGet: async (eventId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV1EventsEventIdEntriesGet', 'eventId', eventId)
            const localVarPath = `/api/v1/events/{event_id}/entries`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Event Entry
         * @param {number} eventId 
         * @param {EventEntryCreateRequest} eventEntryCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EventsEventIdEntriesPost: async (eventId: number, eventEntryCreateRequest: EventEntryCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV1EventsEventIdEntriesPost', 'eventId', eventId)
            // verify required parameter 'eventEntryCreateRequest' is not null or undefined
            assertParamExists('apiV1EventsEventIdEntriesPost', 'eventEntryCreateRequest', eventEntryCreateRequest)
            const localVarPath = `/api/v1/events/{event_id}/entries`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventEntryCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Events
         * @param {string | null} [subSite] Sub site code to filter events (e.g. \&#39;typing\&#39;). Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EventsGet: async (subSite?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/events/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (subSite !== undefined) {
                localVarQueryParameter['sub_site'] = subSite;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventApi - functional programming interface
 * @export
 */
export const EventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Event Entries
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EventsEventIdEntriesGet(eventId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EventsEventIdEntriesGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.apiV1EventsEventIdEntriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Event Entry
         * @param {number} eventId 
         * @param {EventEntryCreateRequest} eventEntryCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EventsEventIdEntriesPost(eventId: number, eventEntryCreateRequest: EventEntryCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntryCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EventsEventIdEntriesPost(eventId, eventEntryCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.apiV1EventsEventIdEntriesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Events
         * @param {string | null} [subSite] Sub site code to filter events (e.g. \&#39;typing\&#39;). Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EventsGet(subSite?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EventsGet(subSite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.apiV1EventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventApi - factory interface
 * @export
 */
export const EventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Event Entries
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EventsEventIdEntriesGet(eventId: number, options?: RawAxiosRequestConfig): AxiosPromise<EventEntryListResponse> {
            return localVarFp.apiV1EventsEventIdEntriesGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Event Entry
         * @param {number} eventId 
         * @param {EventEntryCreateRequest} eventEntryCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EventsEventIdEntriesPost(eventId: number, eventEntryCreateRequest: EventEntryCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventEntryCreateResponse> {
            return localVarFp.apiV1EventsEventIdEntriesPost(eventId, eventEntryCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Events
         * @param {string | null} [subSite] Sub site code to filter events (e.g. \&#39;typing\&#39;). Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EventsGet(subSite?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<EventListResponse> {
            return localVarFp.apiV1EventsGet(subSite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventApi - object-oriented interface
 * @export
 * @class EventApi
 * @extends {BaseAPI}
 */
export class EventApi extends BaseAPI {
    /**
     * 
     * @summary Get Event Entries
     * @param {number} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiV1EventsEventIdEntriesGet(eventId: number, options?: RawAxiosRequestConfig) {
        return EventApiFp(this.configuration).apiV1EventsEventIdEntriesGet(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Event Entry
     * @param {number} eventId 
     * @param {EventEntryCreateRequest} eventEntryCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiV1EventsEventIdEntriesPost(eventId: number, eventEntryCreateRequest: EventEntryCreateRequest, options?: RawAxiosRequestConfig) {
        return EventApiFp(this.configuration).apiV1EventsEventIdEntriesPost(eventId, eventEntryCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Events
     * @param {string | null} [subSite] Sub site code to filter events (e.g. \&#39;typing\&#39;). Optional.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiV1EventsGet(subSite?: string | null, options?: RawAxiosRequestConfig) {
        return EventApiFp(this.configuration).apiV1EventsGet(subSite, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExternalApi - axios parameter creator
 * @export
 */
export const ExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get active course codes for license users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ExternalLicenseUserActiveCoursesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/external/license/user/active-courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalApi - functional programming interface
 * @export
 */
export const ExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get active course codes for license users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ExternalLicenseUserActiveCoursesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserActiveCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ExternalLicenseUserActiveCoursesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalApi.apiV1ExternalLicenseUserActiveCoursesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalApi - factory interface
 * @export
 */
export const ExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalApiFp(configuration)
    return {
        /**
         * 
         * @summary Get active course codes for license users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ExternalLicenseUserActiveCoursesGet(options?: RawAxiosRequestConfig): AxiosPromise<UserActiveCoursesResponse> {
            return localVarFp.apiV1ExternalLicenseUserActiveCoursesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalApi - object-oriented interface
 * @export
 * @class ExternalApi
 * @extends {BaseAPI}
 */
export class ExternalApi extends BaseAPI {
    /**
     * 
     * @summary Get active course codes for license users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalApi
     */
    public apiV1ExternalLicenseUserActiveCoursesGet(options?: RawAxiosRequestConfig) {
        return ExternalApiFp(this.configuration).apiV1ExternalLicenseUserActiveCoursesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LearningLogsApi - axios parameter creator
 * @export
 */
export const LearningLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ユーザーに紐づく最新100件の学習ログを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LearningLogsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/learning_logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LearningLogsApi - functional programming interface
 * @export
 */
export const LearningLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LearningLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ユーザーに紐づく最新100件の学習ログを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LearningLogsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningLogsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LearningLogsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LearningLogsApi.apiV1LearningLogsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LearningLogsApi - factory interface
 * @export
 */
export const LearningLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LearningLogsApiFp(configuration)
    return {
        /**
         * 
         * @summary ユーザーに紐づく最新100件の学習ログを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LearningLogsGet(options?: RawAxiosRequestConfig): AxiosPromise<LearningLogsListResponse> {
            return localVarFp.apiV1LearningLogsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LearningLogsApi - object-oriented interface
 * @export
 * @class LearningLogsApi
 * @extends {BaseAPI}
 */
export class LearningLogsApi extends BaseAPI {
    /**
     * 
     * @summary ユーザーに紐づく最新100件の学習ログを取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningLogsApi
     */
    public apiV1LearningLogsGet(options?: RawAxiosRequestConfig) {
        return LearningLogsApiFp(this.configuration).apiV1LearningLogsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LineApi - axios parameter creator
 * @export
 */
export const LineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Send video URL to LINE via MicoCloud API
         * @param {string} micoTemplateId MicoCloud template ID
         * @param {string} video Video file in WebM format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LineSendVideoPost: async (micoTemplateId: string, video: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'micoTemplateId' is not null or undefined
            assertParamExists('apiV1LineSendVideoPost', 'micoTemplateId', micoTemplateId)
            // verify required parameter 'video' is not null or undefined
            assertParamExists('apiV1LineSendVideoPost', 'video', video)
            const localVarPath = `/api/v1/line/send/video`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


            if (micoTemplateId !== undefined) { 
                localVarFormParams.set('mico_template_id', micoTemplateId as any);
            }
    
            if (video !== undefined) { 
                localVarFormParams.set('video', video as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LineApi - functional programming interface
 * @export
 */
export const LineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LineApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Send video URL to LINE via MicoCloud API
         * @param {string} micoTemplateId MicoCloud template ID
         * @param {string} video Video file in WebM format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LineSendVideoPost(micoTemplateId: string, video: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendVideoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LineSendVideoPost(micoTemplateId, video, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LineApi.apiV1LineSendVideoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LineApi - factory interface
 * @export
 */
export const LineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LineApiFp(configuration)
    return {
        /**
         * 
         * @summary Send video URL to LINE via MicoCloud API
         * @param {string} micoTemplateId MicoCloud template ID
         * @param {string} video Video file in WebM format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LineSendVideoPost(micoTemplateId: string, video: string, options?: RawAxiosRequestConfig): AxiosPromise<SendVideoResponse> {
            return localVarFp.apiV1LineSendVideoPost(micoTemplateId, video, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LineApi - object-oriented interface
 * @export
 * @class LineApi
 * @extends {BaseAPI}
 */
export class LineApi extends BaseAPI {
    /**
     * 
     * @summary Send video URL to LINE via MicoCloud API
     * @param {string} micoTemplateId MicoCloud template ID
     * @param {string} video Video file in WebM format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineApi
     */
    public apiV1LineSendVideoPost(micoTemplateId: string, video: string, options?: RawAxiosRequestConfig) {
        return LineApiFp(this.configuration).apiV1LineSendVideoPost(micoTemplateId, video, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MissionApi - axios parameter creator
 * @export
 */
export const MissionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 動画モーダル用ミッション情報取得API ミッション以下の詳細情報を取得
         * @param {number | null} [missionId] mission id
         * @param {boolean} [onlyValid] If true, only return valid records based on valid_from/valid_to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissionsGet: async (missionId?: number | null, onlyValid?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/missions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (missionId !== undefined) {
                localVarQueryParameter['mission_id'] = missionId;
            }

            if (onlyValid !== undefined) {
                localVarQueryParameter['only_valid'] = onlyValid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ミッション情報取得API 指定されたミッションIDに対応するStages.seq、Missions.seq、Missions.nameを返却する
         * @param {number} missionId mission id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissionsInfoGet: async (missionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'missionId' is not null or undefined
            assertParamExists('apiV1MissionsInfoGet', 'missionId', missionId)
            const localVarPath = `/api/v1/missions/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (missionId !== undefined) {
                localVarQueryParameter['mission_id'] = missionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 複数ユーザーのミッション進捗情報取得API 各ユーザー1つのミッションの進捗情報を取得
         * @param {MultipleUserMissionProgressRequest} multipleUserMissionProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissionsProgressPost: async (multipleUserMissionProgressRequest: MultipleUserMissionProgressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'multipleUserMissionProgressRequest' is not null or undefined
            assertParamExists('apiV1MissionsProgressPost', 'multipleUserMissionProgressRequest', multipleUserMissionProgressRequest)
            const localVarPath = `/api/v1/missions/progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multipleUserMissionProgressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 単一ユーザーの複数ミッション進捗情報取得API 指定されたユーザーの複数ミッションの進捗情報を取得
         * @param {number} userId 
         * @param {ApiV1MissionsProgressUserIdGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {Array<number>} [missionIds] List of mission IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissionsProgressUserIdGet: async (userId: number, siteName: ApiV1MissionsProgressUserIdGetSiteNameEnum, missionIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1MissionsProgressUserIdGet', 'userId', userId)
            // verify required parameter 'siteName' is not null or undefined
            assertParamExists('apiV1MissionsProgressUserIdGet', 'siteName', siteName)
            const localVarPath = `/api/v1/missions/progress/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (siteName !== undefined) {
                localVarQueryParameter['site_name'] = siteName;
            }

            if (missionIds) {
                localVarQueryParameter['mission_ids'] = missionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 次に視聴すべきミッション取得API
         * @param {string} stageCode Stage code
         * @param {number} missionSeq Mission sequence number
         * @param {ApiV1MissionsRecommendGetSiteNameEnum} [siteName] Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissionsRecommendGet: async (stageCode: string, missionSeq: number, siteName?: ApiV1MissionsRecommendGetSiteNameEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stageCode' is not null or undefined
            assertParamExists('apiV1MissionsRecommendGet', 'stageCode', stageCode)
            // verify required parameter 'missionSeq' is not null or undefined
            assertParamExists('apiV1MissionsRecommendGet', 'missionSeq', missionSeq)
            const localVarPath = `/api/v1/missions/recommend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (stageCode !== undefined) {
                localVarQueryParameter['stage_code'] = stageCode;
            }

            if (missionSeq !== undefined) {
                localVarQueryParameter['mission_seq'] = missionSeq;
            }

            if (siteName !== undefined) {
                localVarQueryParameter['site_name'] = siteName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 単一ユーザーの最新ミッション結果取得API 指定されたユーザーの最新ミッション結果を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissionsResultLatestGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/missions/result/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MissionApi - functional programming interface
 * @export
 */
export const MissionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MissionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 動画モーダル用ミッション情報取得API ミッション以下の詳細情報を取得
         * @param {number | null} [missionId] mission id
         * @param {boolean} [onlyValid] If true, only return valid records based on valid_from/valid_to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissionsGet(missionId?: number | null, onlyValid?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissionsGet(missionId, onlyValid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MissionApi.apiV1MissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ミッション情報取得API 指定されたミッションIDに対応するStages.seq、Missions.seq、Missions.nameを返却する
         * @param {number} missionId mission id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissionsInfoGet(missionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissionInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissionsInfoGet(missionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MissionApi.apiV1MissionsInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 複数ユーザーのミッション進捗情報取得API 各ユーザー1つのミッションの進捗情報を取得
         * @param {MultipleUserMissionProgressRequest} multipleUserMissionProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissionsProgressPost(multipleUserMissionProgressRequest: MultipleUserMissionProgressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissionProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissionsProgressPost(multipleUserMissionProgressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MissionApi.apiV1MissionsProgressPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 単一ユーザーの複数ミッション進捗情報取得API 指定されたユーザーの複数ミッションの進捗情報を取得
         * @param {number} userId 
         * @param {ApiV1MissionsProgressUserIdGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {Array<number>} [missionIds] List of mission IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissionsProgressUserIdGet(userId: number, siteName: ApiV1MissionsProgressUserIdGetSiteNameEnum, missionIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissionProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissionsProgressUserIdGet(userId, siteName, missionIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MissionApi.apiV1MissionsProgressUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 次に視聴すべきミッション取得API
         * @param {string} stageCode Stage code
         * @param {number} missionSeq Mission sequence number
         * @param {ApiV1MissionsRecommendGetSiteNameEnum} [siteName] Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissionsRecommendGet(stageCode: string, missionSeq: number, siteName?: ApiV1MissionsRecommendGetSiteNameEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecommendMissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissionsRecommendGet(stageCode, missionSeq, siteName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MissionApi.apiV1MissionsRecommendGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 単一ユーザーの最新ミッション結果取得API 指定されたユーザーの最新ミッション結果を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissionsResultLatestGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMissionResultDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissionsResultLatestGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MissionApi.apiV1MissionsResultLatestGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MissionApi - factory interface
 * @export
 */
export const MissionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MissionApiFp(configuration)
    return {
        /**
         * 
         * @summary 動画モーダル用ミッション情報取得API ミッション以下の詳細情報を取得
         * @param {number | null} [missionId] mission id
         * @param {boolean} [onlyValid] If true, only return valid records based on valid_from/valid_to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissionsGet(missionId?: number | null, onlyValid?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<MissionResponse> {
            return localVarFp.apiV1MissionsGet(missionId, onlyValid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ミッション情報取得API 指定されたミッションIDに対応するStages.seq、Missions.seq、Missions.nameを返却する
         * @param {number} missionId mission id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissionsInfoGet(missionId: number, options?: RawAxiosRequestConfig): AxiosPromise<MissionInfoResponse> {
            return localVarFp.apiV1MissionsInfoGet(missionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 複数ユーザーのミッション進捗情報取得API 各ユーザー1つのミッションの進捗情報を取得
         * @param {MultipleUserMissionProgressRequest} multipleUserMissionProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissionsProgressPost(multipleUserMissionProgressRequest: MultipleUserMissionProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<MissionProgressResponse> {
            return localVarFp.apiV1MissionsProgressPost(multipleUserMissionProgressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 単一ユーザーの複数ミッション進捗情報取得API 指定されたユーザーの複数ミッションの進捗情報を取得
         * @param {number} userId 
         * @param {ApiV1MissionsProgressUserIdGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {Array<number>} [missionIds] List of mission IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissionsProgressUserIdGet(userId: number, siteName: ApiV1MissionsProgressUserIdGetSiteNameEnum, missionIds?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<MissionProgressResponse> {
            return localVarFp.apiV1MissionsProgressUserIdGet(userId, siteName, missionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 次に視聴すべきミッション取得API
         * @param {string} stageCode Stage code
         * @param {number} missionSeq Mission sequence number
         * @param {ApiV1MissionsRecommendGetSiteNameEnum} [siteName] Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissionsRecommendGet(stageCode: string, missionSeq: number, siteName?: ApiV1MissionsRecommendGetSiteNameEnum, options?: RawAxiosRequestConfig): AxiosPromise<RecommendMissionResponse> {
            return localVarFp.apiV1MissionsRecommendGet(stageCode, missionSeq, siteName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 単一ユーザーの最新ミッション結果取得API 指定されたユーザーの最新ミッション結果を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissionsResultLatestGet(options?: RawAxiosRequestConfig): AxiosPromise<GetMissionResultDataResponse> {
            return localVarFp.apiV1MissionsResultLatestGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MissionApi - object-oriented interface
 * @export
 * @class MissionApi
 * @extends {BaseAPI}
 */
export class MissionApi extends BaseAPI {
    /**
     * 
     * @summary 動画モーダル用ミッション情報取得API ミッション以下の詳細情報を取得
     * @param {number | null} [missionId] mission id
     * @param {boolean} [onlyValid] If true, only return valid records based on valid_from/valid_to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionApi
     */
    public apiV1MissionsGet(missionId?: number | null, onlyValid?: boolean, options?: RawAxiosRequestConfig) {
        return MissionApiFp(this.configuration).apiV1MissionsGet(missionId, onlyValid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ミッション情報取得API 指定されたミッションIDに対応するStages.seq、Missions.seq、Missions.nameを返却する
     * @param {number} missionId mission id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionApi
     */
    public apiV1MissionsInfoGet(missionId: number, options?: RawAxiosRequestConfig) {
        return MissionApiFp(this.configuration).apiV1MissionsInfoGet(missionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 複数ユーザーのミッション進捗情報取得API 各ユーザー1つのミッションの進捗情報を取得
     * @param {MultipleUserMissionProgressRequest} multipleUserMissionProgressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionApi
     */
    public apiV1MissionsProgressPost(multipleUserMissionProgressRequest: MultipleUserMissionProgressRequest, options?: RawAxiosRequestConfig) {
        return MissionApiFp(this.configuration).apiV1MissionsProgressPost(multipleUserMissionProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 単一ユーザーの複数ミッション進捗情報取得API 指定されたユーザーの複数ミッションの進捗情報を取得
     * @param {number} userId 
     * @param {ApiV1MissionsProgressUserIdGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
     * @param {Array<number>} [missionIds] List of mission IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionApi
     */
    public apiV1MissionsProgressUserIdGet(userId: number, siteName: ApiV1MissionsProgressUserIdGetSiteNameEnum, missionIds?: Array<number>, options?: RawAxiosRequestConfig) {
        return MissionApiFp(this.configuration).apiV1MissionsProgressUserIdGet(userId, siteName, missionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 次に視聴すべきミッション取得API
     * @param {string} stageCode Stage code
     * @param {number} missionSeq Mission sequence number
     * @param {ApiV1MissionsRecommendGetSiteNameEnum} [siteName] Site name, either \&#39;online\&#39; or \&#39;license\&#39;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionApi
     */
    public apiV1MissionsRecommendGet(stageCode: string, missionSeq: number, siteName?: ApiV1MissionsRecommendGetSiteNameEnum, options?: RawAxiosRequestConfig) {
        return MissionApiFp(this.configuration).apiV1MissionsRecommendGet(stageCode, missionSeq, siteName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 単一ユーザーの最新ミッション結果取得API 指定されたユーザーの最新ミッション結果を取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionApi
     */
    public apiV1MissionsResultLatestGet(options?: RawAxiosRequestConfig) {
        return MissionApiFp(this.configuration).apiV1MissionsResultLatestGet(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiV1MissionsProgressUserIdGetSiteNameEnum = {
    Online: 'online',
    License: 'license'
} as const;
export type ApiV1MissionsProgressUserIdGetSiteNameEnum = typeof ApiV1MissionsProgressUserIdGetSiteNameEnum[keyof typeof ApiV1MissionsProgressUserIdGetSiteNameEnum];
/**
 * @export
 */
export const ApiV1MissionsRecommendGetSiteNameEnum = {
    Online: 'online',
    License: 'license'
} as const;
export type ApiV1MissionsRecommendGetSiteNameEnum = typeof ApiV1MissionsRecommendGetSiteNameEnum[keyof typeof ApiV1MissionsRecommendGetSiteNameEnum];


/**
 * OperationResultApi - axios parameter creator
 * @export
 */
export const OperationResultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ログインユーザーのトークンからユーザー情報を取得し、 指定された code に対応する exp を検索して、 OperationResults レコードを作成する。
         * @param {CreateOperationResultRequest} createOperationResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationResultsPost: async (createOperationResultRequest: CreateOperationResultRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOperationResultRequest' is not null or undefined
            assertParamExists('apiV1OperationResultsPost', 'createOperationResultRequest', createOperationResultRequest)
            const localVarPath = `/api/v1/operation_results/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOperationResultRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperationResultApi - functional programming interface
 * @export
 */
export const OperationResultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperationResultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ログインユーザーのトークンからユーザー情報を取得し、 指定された code に対応する exp を検索して、 OperationResults レコードを作成する。
         * @param {CreateOperationResultRequest} createOperationResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationResultsPost(createOperationResultRequest: CreateOperationResultRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOperationResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationResultsPost(createOperationResultRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperationResultApi.apiV1OperationResultsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OperationResultApi - factory interface
 * @export
 */
export const OperationResultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperationResultApiFp(configuration)
    return {
        /**
         * 
         * @summary ログインユーザーのトークンからユーザー情報を取得し、 指定された code に対応する exp を検索して、 OperationResults レコードを作成する。
         * @param {CreateOperationResultRequest} createOperationResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationResultsPost(createOperationResultRequest: CreateOperationResultRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOperationResultResponse> {
            return localVarFp.apiV1OperationResultsPost(createOperationResultRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OperationResultApi - object-oriented interface
 * @export
 * @class OperationResultApi
 * @extends {BaseAPI}
 */
export class OperationResultApi extends BaseAPI {
    /**
     * 
     * @summary ログインユーザーのトークンからユーザー情報を取得し、 指定された code に対応する exp を検索して、 OperationResults レコードを作成する。
     * @param {CreateOperationResultRequest} createOperationResultRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationResultApi
     */
    public apiV1OperationResultsPost(createOperationResultRequest: CreateOperationResultRequest, options?: RawAxiosRequestConfig) {
        return OperationResultApiFp(this.configuration).apiV1OperationResultsPost(createOperationResultRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RewardApi - axios parameter creator
 * @export
 */
export const RewardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns: GetRewardListResponse: リワード情報
         * @summary [GET] リワード を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RewardsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/rewards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RewardApi - functional programming interface
 * @export
 */
export const RewardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RewardApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns: GetRewardListResponse: リワード情報
         * @summary [GET] リワード を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RewardsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRewardListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RewardsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardApi.apiV1RewardsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RewardApi - factory interface
 * @export
 */
export const RewardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RewardApiFp(configuration)
    return {
        /**
         * Returns: GetRewardListResponse: リワード情報
         * @summary [GET] リワード を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RewardsGet(options?: RawAxiosRequestConfig): AxiosPromise<GetRewardListResponse> {
            return localVarFp.apiV1RewardsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RewardApi - object-oriented interface
 * @export
 * @class RewardApi
 * @extends {BaseAPI}
 */
export class RewardApi extends BaseAPI {
    /**
     * Returns: GetRewardListResponse: リワード情報
     * @summary [GET] リワード を取得する API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardApi
     */
    public apiV1RewardsGet(options?: RawAxiosRequestConfig) {
        return RewardApiFp(this.configuration).apiV1RewardsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SetupApi - axios parameter creator
 * @export
 */
export const SetupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch setups
         * @param {ApiV1SetupsGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {string} stageCode stage code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SetupsGet: async (siteName: ApiV1SetupsGetSiteNameEnum, stageCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteName' is not null or undefined
            assertParamExists('apiV1SetupsGet', 'siteName', siteName)
            // verify required parameter 'stageCode' is not null or undefined
            assertParamExists('apiV1SetupsGet', 'stageCode', stageCode)
            const localVarPath = `/api/v1/setups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (siteName !== undefined) {
                localVarQueryParameter['site_name'] = siteName;
            }

            if (stageCode !== undefined) {
                localVarQueryParameter['stage_code'] = stageCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SetupApi - functional programming interface
 * @export
 */
export const SetupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SetupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Fetch setups
         * @param {ApiV1SetupsGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {string} stageCode stage code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SetupsGet(siteName: ApiV1SetupsGetSiteNameEnum, stageCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetupListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SetupsGet(siteName, stageCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SetupApi.apiV1SetupsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SetupApi - factory interface
 * @export
 */
export const SetupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SetupApiFp(configuration)
    return {
        /**
         * 
         * @summary Fetch setups
         * @param {ApiV1SetupsGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {string} stageCode stage code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SetupsGet(siteName: ApiV1SetupsGetSiteNameEnum, stageCode: string, options?: RawAxiosRequestConfig): AxiosPromise<SetupListResponse> {
            return localVarFp.apiV1SetupsGet(siteName, stageCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SetupApi - object-oriented interface
 * @export
 * @class SetupApi
 * @extends {BaseAPI}
 */
export class SetupApi extends BaseAPI {
    /**
     * 
     * @summary Fetch setups
     * @param {ApiV1SetupsGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
     * @param {string} stageCode stage code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetupApi
     */
    public apiV1SetupsGet(siteName: ApiV1SetupsGetSiteNameEnum, stageCode: string, options?: RawAxiosRequestConfig) {
        return SetupApiFp(this.configuration).apiV1SetupsGet(siteName, stageCode, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiV1SetupsGetSiteNameEnum = {
    Online: 'online',
    License: 'license'
} as const;
export type ApiV1SetupsGetSiteNameEnum = typeof ApiV1SetupsGetSiteNameEnum[keyof typeof ApiV1SetupsGetSiteNameEnum];


/**
 * StageApi - axios parameter creator
 * @export
 */
export const StageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch stages
         * @param {ApiV1StagesGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {boolean | null} [joinResults] Flag to join results with authentication
         * @param {Array<string> | null} [codes] List of stage codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StagesGet: async (siteName: ApiV1StagesGetSiteNameEnum, joinResults?: boolean | null, codes?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteName' is not null or undefined
            assertParamExists('apiV1StagesGet', 'siteName', siteName)
            const localVarPath = `/api/v1/stages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (siteName !== undefined) {
                localVarQueryParameter['site_name'] = siteName;
            }

            if (joinResults !== undefined) {
                localVarQueryParameter['join_results'] = joinResults;
            }

            if (codes) {
                localVarQueryParameter['codes'] = codes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch overview stage information (code, mission.num, mission.title, mission.private only)
         * @param {ApiV1StagesOverviewGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StagesOverviewGet: async (siteName: ApiV1StagesOverviewGetSiteNameEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteName' is not null or undefined
            assertParamExists('apiV1StagesOverviewGet', 'siteName', siteName)
            const localVarPath = `/api/v1/stages/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (siteName !== undefined) {
                localVarQueryParameter['site_name'] = siteName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StageApi - functional programming interface
 * @export
 */
export const StageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Fetch stages
         * @param {ApiV1StagesGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {boolean | null} [joinResults] Flag to join results with authentication
         * @param {Array<string> | null} [codes] List of stage codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StagesGet(siteName: ApiV1StagesGetSiteNameEnum, joinResults?: boolean | null, codes?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StageListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StagesGet(siteName, joinResults, codes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StageApi.apiV1StagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch overview stage information (code, mission.num, mission.title, mission.private only)
         * @param {ApiV1StagesOverviewGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StagesOverviewGet(siteName: ApiV1StagesOverviewGetSiteNameEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OverviewStageListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StagesOverviewGet(siteName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StageApi.apiV1StagesOverviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StageApi - factory interface
 * @export
 */
export const StageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StageApiFp(configuration)
    return {
        /**
         * 
         * @summary Fetch stages
         * @param {ApiV1StagesGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {boolean | null} [joinResults] Flag to join results with authentication
         * @param {Array<string> | null} [codes] List of stage codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StagesGet(siteName: ApiV1StagesGetSiteNameEnum, joinResults?: boolean | null, codes?: Array<string> | null, options?: RawAxiosRequestConfig): AxiosPromise<StageListResponse> {
            return localVarFp.apiV1StagesGet(siteName, joinResults, codes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch overview stage information (code, mission.num, mission.title, mission.private only)
         * @param {ApiV1StagesOverviewGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StagesOverviewGet(siteName: ApiV1StagesOverviewGetSiteNameEnum, options?: RawAxiosRequestConfig): AxiosPromise<OverviewStageListResponse> {
            return localVarFp.apiV1StagesOverviewGet(siteName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StageApi - object-oriented interface
 * @export
 * @class StageApi
 * @extends {BaseAPI}
 */
export class StageApi extends BaseAPI {
    /**
     * 
     * @summary Fetch stages
     * @param {ApiV1StagesGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
     * @param {boolean | null} [joinResults] Flag to join results with authentication
     * @param {Array<string> | null} [codes] List of stage codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageApi
     */
    public apiV1StagesGet(siteName: ApiV1StagesGetSiteNameEnum, joinResults?: boolean | null, codes?: Array<string> | null, options?: RawAxiosRequestConfig) {
        return StageApiFp(this.configuration).apiV1StagesGet(siteName, joinResults, codes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch overview stage information (code, mission.num, mission.title, mission.private only)
     * @param {ApiV1StagesOverviewGetSiteNameEnum} siteName Site name, either \&#39;online\&#39; or \&#39;license\&#39;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageApi
     */
    public apiV1StagesOverviewGet(siteName: ApiV1StagesOverviewGetSiteNameEnum, options?: RawAxiosRequestConfig) {
        return StageApiFp(this.configuration).apiV1StagesOverviewGet(siteName, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiV1StagesGetSiteNameEnum = {
    Online: 'online',
    License: 'license'
} as const;
export type ApiV1StagesGetSiteNameEnum = typeof ApiV1StagesGetSiteNameEnum[keyof typeof ApiV1StagesGetSiteNameEnum];
/**
 * @export
 */
export const ApiV1StagesOverviewGetSiteNameEnum = {
    Online: 'online',
    License: 'license'
} as const;
export type ApiV1StagesOverviewGetSiteNameEnum = typeof ApiV1StagesOverviewGetSiteNameEnum[keyof typeof ApiV1StagesOverviewGetSiteNameEnum];


/**
 * StampApi - axios parameter creator
 * @export
 */
export const StampApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns: GetStampsListResponse: スタンプ情報
         * @summary [GET] stamp を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StampsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/stamps/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StampApi - functional programming interface
 * @export
 */
export const StampApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StampApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns: GetStampsListResponse: スタンプ情報
         * @summary [GET] stamp を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StampsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStampListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StampsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StampApi.apiV1StampsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StampApi - factory interface
 * @export
 */
export const StampApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StampApiFp(configuration)
    return {
        /**
         * Returns: GetStampsListResponse: スタンプ情報
         * @summary [GET] stamp を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StampsGet(options?: RawAxiosRequestConfig): AxiosPromise<GetStampListResponse> {
            return localVarFp.apiV1StampsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StampApi - object-oriented interface
 * @export
 * @class StampApi
 * @extends {BaseAPI}
 */
export class StampApi extends BaseAPI {
    /**
     * Returns: GetStampsListResponse: スタンプ情報
     * @summary [GET] stamp を取得する API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StampApi
     */
    public apiV1StampsGet(options?: RawAxiosRequestConfig) {
        return StampApiFp(this.configuration).apiV1StampsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StudyModesApi - axios parameter creator
 * @export
 */
export const StudyModesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 学習モードと学習コースのマスタデータを取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StudyModesCoursesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/study_modes/courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 未取得のミッションIDリストを取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StudyModesMissionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/study_modes/missions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 指定ミッションの is_acquired を True に更新
         * @param {UpdateStudyMissionAcquiredRequest} updateStudyMissionAcquiredRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StudyModesMissionsPatch: async (updateStudyMissionAcquiredRequest: UpdateStudyMissionAcquiredRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateStudyMissionAcquiredRequest' is not null or undefined
            assertParamExists('apiV1StudyModesMissionsPatch', 'updateStudyMissionAcquiredRequest', updateStudyMissionAcquiredRequest)
            const localVarPath = `/api/v1/study_modes/missions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStudyMissionAcquiredRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StudyModesApi - functional programming interface
 * @export
 */
export const StudyModesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StudyModesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 学習モードと学習コースのマスタデータを取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StudyModesCoursesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudyModeItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StudyModesCoursesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyModesApi.apiV1StudyModesCoursesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 未取得のミッションIDリストを取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StudyModesMissionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnacquiredMissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StudyModesMissionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyModesApi.apiV1StudyModesMissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 指定ミッションの is_acquired を True に更新
         * @param {UpdateStudyMissionAcquiredRequest} updateStudyMissionAcquiredRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StudyModesMissionsPatch(updateStudyMissionAcquiredRequest: UpdateStudyMissionAcquiredRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateStudyMissionAcquiredResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StudyModesMissionsPatch(updateStudyMissionAcquiredRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyModesApi.apiV1StudyModesMissionsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StudyModesApi - factory interface
 * @export
 */
export const StudyModesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StudyModesApiFp(configuration)
    return {
        /**
         * 
         * @summary 学習モードと学習コースのマスタデータを取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StudyModesCoursesGet(options?: RawAxiosRequestConfig): AxiosPromise<StudyModeItemsResponse> {
            return localVarFp.apiV1StudyModesCoursesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 未取得のミッションIDリストを取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StudyModesMissionsGet(options?: RawAxiosRequestConfig): AxiosPromise<GetUnacquiredMissionsResponse> {
            return localVarFp.apiV1StudyModesMissionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 指定ミッションの is_acquired を True に更新
         * @param {UpdateStudyMissionAcquiredRequest} updateStudyMissionAcquiredRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StudyModesMissionsPatch(updateStudyMissionAcquiredRequest: UpdateStudyMissionAcquiredRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateStudyMissionAcquiredResponse> {
            return localVarFp.apiV1StudyModesMissionsPatch(updateStudyMissionAcquiredRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StudyModesApi - object-oriented interface
 * @export
 * @class StudyModesApi
 * @extends {BaseAPI}
 */
export class StudyModesApi extends BaseAPI {
    /**
     * 
     * @summary 学習モードと学習コースのマスタデータを取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyModesApi
     */
    public apiV1StudyModesCoursesGet(options?: RawAxiosRequestConfig) {
        return StudyModesApiFp(this.configuration).apiV1StudyModesCoursesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 未取得のミッションIDリストを取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyModesApi
     */
    public apiV1StudyModesMissionsGet(options?: RawAxiosRequestConfig) {
        return StudyModesApiFp(this.configuration).apiV1StudyModesMissionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 指定ミッションの is_acquired を True に更新
     * @param {UpdateStudyMissionAcquiredRequest} updateStudyMissionAcquiredRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyModesApi
     */
    public apiV1StudyModesMissionsPatch(updateStudyMissionAcquiredRequest: UpdateStudyMissionAcquiredRequest, options?: RawAxiosRequestConfig) {
        return StudyModesApiFp(this.configuration).apiV1StudyModesMissionsPatch(updateStudyMissionAcquiredRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TypingApi - axios parameter creator
 * @export
 */
export const TypingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get best scores per theme API
         * @param {Array<ApiV1TypingBestScoresGetThemeTypesEnum>} themeTypes 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingBestScoresGet: async (themeTypes: Array<ApiV1TypingBestScoresGetThemeTypesEnum>, dateFrom?: string | null, dateTo?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'themeTypes' is not null or undefined
            assertParamExists('apiV1TypingBestScoresGet', 'themeTypes', themeTypes)
            const localVarPath = `/api/v1/typing/best-scores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (themeTypes) {
                localVarQueryParameter['theme_types'] = themeTypes;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get typing characters API
         * @param {string} themeType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingCharactersGet: async (themeType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'themeType' is not null or undefined
            assertParamExists('apiV1TypingCharactersGet', 'themeType', themeType)
            const localVarPath = `/api/v1/typing/characters/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (themeType !== undefined) {
                localVarQueryParameter['theme_type'] = themeType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get grades current API - shows cleared grade for each theme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingGradesCurrentGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/typing/grades/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get typing grade API
         * @param {ApiV1TypingGradesGetThemeTypeEnum} themeType 
         * @param {number | null} [gradeNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingGradesGet: async (themeType: ApiV1TypingGradesGetThemeTypeEnum, gradeNumber?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'themeType' is not null or undefined
            assertParamExists('apiV1TypingGradesGet', 'themeType', themeType)
            const localVarPath = `/api/v1/typing/grades`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (themeType !== undefined) {
                localVarQueryParameter['theme_type'] = themeType;
            }

            if (gradeNumber !== undefined) {
                localVarQueryParameter['grade_number'] = gradeNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete typing grade API
         * @param {number} gradeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingGradesGradeIdDelete: async (gradeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gradeId' is not null or undefined
            assertParamExists('apiV1TypingGradesGradeIdDelete', 'gradeId', gradeId)
            const localVarPath = `/api/v1/typing/grades/{grade_id}`
                .replace(`{${"grade_id"}}`, encodeURIComponent(String(gradeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update typing grade API
         * @param {number} gradeId 
         * @param {TypingUpdateGradeRequest} typingUpdateGradeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingGradesGradeIdPatch: async (gradeId: number, typingUpdateGradeRequest: TypingUpdateGradeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gradeId' is not null or undefined
            assertParamExists('apiV1TypingGradesGradeIdPatch', 'gradeId', gradeId)
            // verify required parameter 'typingUpdateGradeRequest' is not null or undefined
            assertParamExists('apiV1TypingGradesGradeIdPatch', 'typingUpdateGradeRequest', typingUpdateGradeRequest)
            const localVarPath = `/api/v1/typing/grades/{grade_id}`
                .replace(`{${"grade_id"}}`, encodeURIComponent(String(gradeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(typingUpdateGradeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insert typing grade API
         * @param {number} gradeId 
         * @param {TypingInsertGradeRequest} typingInsertGradeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingGradesGradeIdPost: async (gradeId: number, typingInsertGradeRequest: TypingInsertGradeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gradeId' is not null or undefined
            assertParamExists('apiV1TypingGradesGradeIdPost', 'gradeId', gradeId)
            // verify required parameter 'typingInsertGradeRequest' is not null or undefined
            assertParamExists('apiV1TypingGradesGradeIdPost', 'typingInsertGradeRequest', typingInsertGradeRequest)
            const localVarPath = `/api/v1/typing/grades/{grade_id}`
                .replace(`{${"grade_id"}}`, encodeURIComponent(String(gradeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(typingInsertGradeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get typing results API
         * @param {ApiV1TypingResultsGetThemeTypeEnum} themeType 
         * @param {number | null} [gradeNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingResultsGet: async (themeType: ApiV1TypingResultsGetThemeTypeEnum, gradeNumber?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'themeType' is not null or undefined
            assertParamExists('apiV1TypingResultsGet', 'themeType', themeType)
            const localVarPath = `/api/v1/typing/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (themeType !== undefined) {
                localVarQueryParameter['theme_type'] = themeType;
            }

            if (gradeNumber !== undefined) {
                localVarQueryParameter['grade_number'] = gradeNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insert typing results API
         * @param {TypingInsertResultRequest} typingInsertResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingResultsPost: async (typingInsertResultRequest: TypingInsertResultRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typingInsertResultRequest' is not null or undefined
            assertParamExists('apiV1TypingResultsPost', 'typingInsertResultRequest', typingInsertResultRequest)
            const localVarPath = `/api/v1/typing/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(typingInsertResultRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get typing word API
         * @param {number} gradeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingWordsGet: async (gradeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gradeId' is not null or undefined
            assertParamExists('apiV1TypingWordsGet', 'gradeId', gradeId)
            const localVarPath = `/api/v1/typing/words/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (gradeId !== undefined) {
                localVarQueryParameter['grade_id'] = gradeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insert typing word API
         * @param {TypingInsertWordRequest} typingInsertWordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingWordsPost: async (typingInsertWordRequest: TypingInsertWordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typingInsertWordRequest' is not null or undefined
            assertParamExists('apiV1TypingWordsPost', 'typingInsertWordRequest', typingInsertWordRequest)
            const localVarPath = `/api/v1/typing/words/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(typingInsertWordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete typing word API
         * @param {number} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingWordsWordIdDelete: async (wordId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wordId' is not null or undefined
            assertParamExists('apiV1TypingWordsWordIdDelete', 'wordId', wordId)
            const localVarPath = `/api/v1/typing/words/{word_id}`
                .replace(`{${"word_id"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get typing word API
         * @param {number} wordId 
         * @param {TypingUpdateWordRequest} typingUpdateWordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingWordsWordIdPatch: async (wordId: number, typingUpdateWordRequest: TypingUpdateWordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wordId' is not null or undefined
            assertParamExists('apiV1TypingWordsWordIdPatch', 'wordId', wordId)
            // verify required parameter 'typingUpdateWordRequest' is not null or undefined
            assertParamExists('apiV1TypingWordsWordIdPatch', 'typingUpdateWordRequest', typingUpdateWordRequest)
            const localVarPath = `/api/v1/typing/words/{word_id}`
                .replace(`{${"word_id"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(typingUpdateWordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TypingApi - functional programming interface
 * @export
 */
export const TypingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TypingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get best scores per theme API
         * @param {Array<ApiV1TypingBestScoresGetThemeTypesEnum>} themeTypes 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingBestScoresGet(themeTypes: Array<ApiV1TypingBestScoresGetThemeTypesEnum>, dateFrom?: string | null, dateTo?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingGetBestScoresResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingBestScoresGet(themeTypes, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingBestScoresGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get typing characters API
         * @param {string} themeType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingCharactersGet(themeType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingGetCharacterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingCharactersGet(themeType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingCharactersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get grades current API - shows cleared grade for each theme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingGradesCurrentGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingGetGradesCurrentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingGradesCurrentGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingGradesCurrentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get typing grade API
         * @param {ApiV1TypingGradesGetThemeTypeEnum} themeType 
         * @param {number | null} [gradeNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingGradesGet(themeType: ApiV1TypingGradesGetThemeTypeEnum, gradeNumber?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingGetGradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingGradesGet(themeType, gradeNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingGradesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete typing grade API
         * @param {number} gradeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingGradesGradeIdDelete(gradeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingDeleteGradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingGradesGradeIdDelete(gradeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingGradesGradeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update typing grade API
         * @param {number} gradeId 
         * @param {TypingUpdateGradeRequest} typingUpdateGradeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingGradesGradeIdPatch(gradeId: number, typingUpdateGradeRequest: TypingUpdateGradeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingUpdateGradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingGradesGradeIdPatch(gradeId, typingUpdateGradeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingGradesGradeIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insert typing grade API
         * @param {number} gradeId 
         * @param {TypingInsertGradeRequest} typingInsertGradeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingGradesGradeIdPost(gradeId: number, typingInsertGradeRequest: TypingInsertGradeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingInsertGradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingGradesGradeIdPost(gradeId, typingInsertGradeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingGradesGradeIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get typing results API
         * @param {ApiV1TypingResultsGetThemeTypeEnum} themeType 
         * @param {number | null} [gradeNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingResultsGet(themeType: ApiV1TypingResultsGetThemeTypeEnum, gradeNumber?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingGetResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingResultsGet(themeType, gradeNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insert typing results API
         * @param {TypingInsertResultRequest} typingInsertResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingResultsPost(typingInsertResultRequest: TypingInsertResultRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingInsertResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingResultsPost(typingInsertResultRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingResultsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get typing word API
         * @param {number} gradeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingWordsGet(gradeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingGetWordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingWordsGet(gradeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingWordsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insert typing word API
         * @param {TypingInsertWordRequest} typingInsertWordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingWordsPost(typingInsertWordRequest: TypingInsertWordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingInsertWordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingWordsPost(typingInsertWordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingWordsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete typing word API
         * @param {number} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingWordsWordIdDelete(wordId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingDeleteWordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingWordsWordIdDelete(wordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingWordsWordIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get typing word API
         * @param {number} wordId 
         * @param {TypingUpdateWordRequest} typingUpdateWordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TypingWordsWordIdPatch(wordId: number, typingUpdateWordRequest: TypingUpdateWordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingUpdateWordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TypingWordsWordIdPatch(wordId, typingUpdateWordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.apiV1TypingWordsWordIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TypingApi - factory interface
 * @export
 */
export const TypingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TypingApiFp(configuration)
    return {
        /**
         * 
         * @summary Get best scores per theme API
         * @param {Array<ApiV1TypingBestScoresGetThemeTypesEnum>} themeTypes 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingBestScoresGet(themeTypes: Array<ApiV1TypingBestScoresGetThemeTypesEnum>, dateFrom?: string | null, dateTo?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<TypingGetBestScoresResponse> {
            return localVarFp.apiV1TypingBestScoresGet(themeTypes, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get typing characters API
         * @param {string} themeType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingCharactersGet(themeType: string, options?: RawAxiosRequestConfig): AxiosPromise<TypingGetCharacterResponse> {
            return localVarFp.apiV1TypingCharactersGet(themeType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get grades current API - shows cleared grade for each theme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingGradesCurrentGet(options?: RawAxiosRequestConfig): AxiosPromise<TypingGetGradesCurrentResponse> {
            return localVarFp.apiV1TypingGradesCurrentGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get typing grade API
         * @param {ApiV1TypingGradesGetThemeTypeEnum} themeType 
         * @param {number | null} [gradeNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingGradesGet(themeType: ApiV1TypingGradesGetThemeTypeEnum, gradeNumber?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<TypingGetGradeResponse> {
            return localVarFp.apiV1TypingGradesGet(themeType, gradeNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete typing grade API
         * @param {number} gradeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingGradesGradeIdDelete(gradeId: number, options?: RawAxiosRequestConfig): AxiosPromise<TypingDeleteGradeResponse> {
            return localVarFp.apiV1TypingGradesGradeIdDelete(gradeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update typing grade API
         * @param {number} gradeId 
         * @param {TypingUpdateGradeRequest} typingUpdateGradeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingGradesGradeIdPatch(gradeId: number, typingUpdateGradeRequest: TypingUpdateGradeRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypingUpdateGradeResponse> {
            return localVarFp.apiV1TypingGradesGradeIdPatch(gradeId, typingUpdateGradeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insert typing grade API
         * @param {number} gradeId 
         * @param {TypingInsertGradeRequest} typingInsertGradeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingGradesGradeIdPost(gradeId: number, typingInsertGradeRequest: TypingInsertGradeRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypingInsertGradeResponse> {
            return localVarFp.apiV1TypingGradesGradeIdPost(gradeId, typingInsertGradeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get typing results API
         * @param {ApiV1TypingResultsGetThemeTypeEnum} themeType 
         * @param {number | null} [gradeNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingResultsGet(themeType: ApiV1TypingResultsGetThemeTypeEnum, gradeNumber?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<TypingGetResultResponse> {
            return localVarFp.apiV1TypingResultsGet(themeType, gradeNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insert typing results API
         * @param {TypingInsertResultRequest} typingInsertResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingResultsPost(typingInsertResultRequest: TypingInsertResultRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypingInsertResultResponse> {
            return localVarFp.apiV1TypingResultsPost(typingInsertResultRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get typing word API
         * @param {number} gradeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingWordsGet(gradeId: number, options?: RawAxiosRequestConfig): AxiosPromise<TypingGetWordResponse> {
            return localVarFp.apiV1TypingWordsGet(gradeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insert typing word API
         * @param {TypingInsertWordRequest} typingInsertWordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingWordsPost(typingInsertWordRequest: TypingInsertWordRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypingInsertWordResponse> {
            return localVarFp.apiV1TypingWordsPost(typingInsertWordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete typing word API
         * @param {number} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingWordsWordIdDelete(wordId: number, options?: RawAxiosRequestConfig): AxiosPromise<TypingDeleteWordResponse> {
            return localVarFp.apiV1TypingWordsWordIdDelete(wordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get typing word API
         * @param {number} wordId 
         * @param {TypingUpdateWordRequest} typingUpdateWordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TypingWordsWordIdPatch(wordId: number, typingUpdateWordRequest: TypingUpdateWordRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypingUpdateWordResponse> {
            return localVarFp.apiV1TypingWordsWordIdPatch(wordId, typingUpdateWordRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TypingApi - object-oriented interface
 * @export
 * @class TypingApi
 * @extends {BaseAPI}
 */
export class TypingApi extends BaseAPI {
    /**
     * 
     * @summary Get best scores per theme API
     * @param {Array<ApiV1TypingBestScoresGetThemeTypesEnum>} themeTypes 
     * @param {string | null} [dateFrom] 
     * @param {string | null} [dateTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingBestScoresGet(themeTypes: Array<ApiV1TypingBestScoresGetThemeTypesEnum>, dateFrom?: string | null, dateTo?: string | null, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingBestScoresGet(themeTypes, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get typing characters API
     * @param {string} themeType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingCharactersGet(themeType: string, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingCharactersGet(themeType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get grades current API - shows cleared grade for each theme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingGradesCurrentGet(options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingGradesCurrentGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get typing grade API
     * @param {ApiV1TypingGradesGetThemeTypeEnum} themeType 
     * @param {number | null} [gradeNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingGradesGet(themeType: ApiV1TypingGradesGetThemeTypeEnum, gradeNumber?: number | null, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingGradesGet(themeType, gradeNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete typing grade API
     * @param {number} gradeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingGradesGradeIdDelete(gradeId: number, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingGradesGradeIdDelete(gradeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update typing grade API
     * @param {number} gradeId 
     * @param {TypingUpdateGradeRequest} typingUpdateGradeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingGradesGradeIdPatch(gradeId: number, typingUpdateGradeRequest: TypingUpdateGradeRequest, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingGradesGradeIdPatch(gradeId, typingUpdateGradeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insert typing grade API
     * @param {number} gradeId 
     * @param {TypingInsertGradeRequest} typingInsertGradeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingGradesGradeIdPost(gradeId: number, typingInsertGradeRequest: TypingInsertGradeRequest, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingGradesGradeIdPost(gradeId, typingInsertGradeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get typing results API
     * @param {ApiV1TypingResultsGetThemeTypeEnum} themeType 
     * @param {number | null} [gradeNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingResultsGet(themeType: ApiV1TypingResultsGetThemeTypeEnum, gradeNumber?: number | null, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingResultsGet(themeType, gradeNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insert typing results API
     * @param {TypingInsertResultRequest} typingInsertResultRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingResultsPost(typingInsertResultRequest: TypingInsertResultRequest, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingResultsPost(typingInsertResultRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get typing word API
     * @param {number} gradeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingWordsGet(gradeId: number, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingWordsGet(gradeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insert typing word API
     * @param {TypingInsertWordRequest} typingInsertWordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingWordsPost(typingInsertWordRequest: TypingInsertWordRequest, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingWordsPost(typingInsertWordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete typing word API
     * @param {number} wordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingWordsWordIdDelete(wordId: number, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingWordsWordIdDelete(wordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get typing word API
     * @param {number} wordId 
     * @param {TypingUpdateWordRequest} typingUpdateWordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public apiV1TypingWordsWordIdPatch(wordId: number, typingUpdateWordRequest: TypingUpdateWordRequest, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).apiV1TypingWordsWordIdPatch(wordId, typingUpdateWordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiV1TypingBestScoresGetThemeTypesEnum = {
    Disney: 'disney',
    Micratch: 'micratch',
    Roblox: 'roblox'
} as const;
export type ApiV1TypingBestScoresGetThemeTypesEnum = typeof ApiV1TypingBestScoresGetThemeTypesEnum[keyof typeof ApiV1TypingBestScoresGetThemeTypesEnum];
/**
 * @export
 */
export const ApiV1TypingGradesGetThemeTypeEnum = {
    Disney: 'disney',
    Micratch: 'micratch',
    Roblox: 'roblox'
} as const;
export type ApiV1TypingGradesGetThemeTypeEnum = typeof ApiV1TypingGradesGetThemeTypeEnum[keyof typeof ApiV1TypingGradesGetThemeTypeEnum];
/**
 * @export
 */
export const ApiV1TypingResultsGetThemeTypeEnum = {
    Disney: 'disney',
    Micratch: 'micratch',
    Roblox: 'roblox'
} as const;
export type ApiV1TypingResultsGetThemeTypeEnum = typeof ApiV1TypingResultsGetThemeTypeEnum[keyof typeof ApiV1TypingResultsGetThemeTypeEnum];


/**
 * UploadApi - axios parameter creator
 * @export
 */
export const UploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ログインユーザーのみ使用可能。 生成されたURLは1時間有効。
         * @summary S3アップロード用Presigned URL生成API
         * @param {PresignedUrlRequest} presignedUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UploadPresignedUrlPost: async (presignedUrlRequest: PresignedUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'presignedUrlRequest' is not null or undefined
            assertParamExists('apiV1UploadPresignedUrlPost', 'presignedUrlRequest', presignedUrlRequest)
            const localVarPath = `/api/v1/upload/presigned-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(presignedUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadApi - functional programming interface
 * @export
 */
export const UploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration)
    return {
        /**
         * ログインユーザーのみ使用可能。 生成されたURLは1時間有効。
         * @summary S3アップロード用Presigned URL生成API
         * @param {PresignedUrlRequest} presignedUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UploadPresignedUrlPost(presignedUrlRequest: PresignedUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PresignedUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UploadPresignedUrlPost(presignedUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UploadApi.apiV1UploadPresignedUrlPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UploadApi - factory interface
 * @export
 */
export const UploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadApiFp(configuration)
    return {
        /**
         * ログインユーザーのみ使用可能。 生成されたURLは1時間有効。
         * @summary S3アップロード用Presigned URL生成API
         * @param {PresignedUrlRequest} presignedUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UploadPresignedUrlPost(presignedUrlRequest: PresignedUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<PresignedUrlResponse> {
            return localVarFp.apiV1UploadPresignedUrlPost(presignedUrlRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
export class UploadApi extends BaseAPI {
    /**
     * ログインユーザーのみ使用可能。 生成されたURLは1時間有効。
     * @summary S3アップロード用Presigned URL生成API
     * @param {PresignedUrlRequest} presignedUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public apiV1UploadPresignedUrlPost(presignedUrlRequest: PresignedUrlRequest, options?: RawAxiosRequestConfig) {
        return UploadApiFp(this.configuration).apiV1UploadPresignedUrlPost(presignedUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change User Password API
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserChangePasswordPost: async (changePasswordRequest: ChangePasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordRequest' is not null or undefined
            assertParamExists('apiV1UserChangePasswordPost', 'changePasswordRequest', changePasswordRequest)
            const localVarPath = `/api/v1/user/change_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Total Exp API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserExpsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/exps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User By Cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Nickname API
         * @param {number} userId user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserNicknameGet: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1UserNicknameGet', 'userId', userId)
            const localVarPath = `/api/v1/user/nickname`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch User By Cookie
         * @param {PatchUserRequest} patchUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserPatch: async (patchUserRequest: PatchUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patchUserRequest' is not null or undefined
            assertParamExists('apiV1UserPatch', 'patchUserRequest', patchUserRequest)
            const localVarPath = `/api/v1/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Profiles API
         * @param {GetUserProfilesRequest} getUserProfilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserProfilesPost: async (getUserProfilesRequest: GetUserProfilesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getUserProfilesRequest' is not null or undefined
            assertParamExists('apiV1UserProfilesPost', 'getUserProfilesRequest', getUserProfilesRequest)
            const localVarPath = `/api/v1/user/profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getUserProfilesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register User API
         * @param {RegisterUserRequest} registerUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRegisterPost: async (registerUserRequest: RegisterUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerUserRequest' is not null or undefined
            assertParamExists('apiV1UserRegisterPost', 'registerUserRequest', registerUserRequest)
            const localVarPath = `/api/v1/user/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new user type history.
         * @param {CreateUserTypeHistoryRequest} createUserTypeHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserTypePost: async (createUserTypeHistoryRequest: CreateUserTypeHistoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserTypeHistoryRequest' is not null or undefined
            assertParamExists('apiV1UserTypePost', 'createUserTypeHistoryRequest', createUserTypeHistoryRequest)
            const localVarPath = `/api/v1/user/type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserTypeHistoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change User Password API
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserChangePasswordPost(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangePasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserChangePasswordPost(changePasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiV1UserChangePasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User Total Exp API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserExpsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserTotalExpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserExpsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiV1UserExpsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User By Cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiV1UserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User Nickname API
         * @param {number} userId user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserNicknameGet(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserNicknameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserNicknameGet(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiV1UserNicknameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Patch User By Cookie
         * @param {PatchUserRequest} patchUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserPatch(patchUserRequest: PatchUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserPatch(patchUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiV1UserPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User Profiles API
         * @param {GetUserProfilesRequest} getUserProfilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserProfilesPost(getUserProfilesRequest: GetUserProfilesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserProfilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserProfilesPost(getUserProfilesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiV1UserProfilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register User API
         * @param {RegisterUserRequest} registerUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserRegisterPost(registerUserRequest: RegisterUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserRegisterPost(registerUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiV1UserRegisterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new user type history.
         * @param {CreateUserTypeHistoryRequest} createUserTypeHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserTypePost(createUserTypeHistoryRequest: CreateUserTypeHistoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserTypeHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserTypePost(createUserTypeHistoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiV1UserTypePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Change User Password API
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserChangePasswordPost(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangePasswordResponse> {
            return localVarFp.apiV1UserChangePasswordPost(changePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Total Exp API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserExpsGet(options?: RawAxiosRequestConfig): AxiosPromise<GetUserTotalExpResponse> {
            return localVarFp.apiV1UserExpsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User By Cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGet(options?: RawAxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.apiV1UserGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Nickname API
         * @param {number} userId user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserNicknameGet(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetUserNicknameResponse> {
            return localVarFp.apiV1UserNicknameGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch User By Cookie
         * @param {PatchUserRequest} patchUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserPatch(patchUserRequest: PatchUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchUserResponse> {
            return localVarFp.apiV1UserPatch(patchUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Profiles API
         * @param {GetUserProfilesRequest} getUserProfilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserProfilesPost(getUserProfilesRequest: GetUserProfilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserProfilesResponse> {
            return localVarFp.apiV1UserProfilesPost(getUserProfilesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register User API
         * @param {RegisterUserRequest} registerUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRegisterPost(registerUserRequest: RegisterUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterUserResponse> {
            return localVarFp.apiV1UserRegisterPost(registerUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new user type history.
         * @param {CreateUserTypeHistoryRequest} createUserTypeHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserTypePost(createUserTypeHistoryRequest: CreateUserTypeHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserTypeHistoryResponse> {
            return localVarFp.apiV1UserTypePost(createUserTypeHistoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Change User Password API
     * @param {ChangePasswordRequest} changePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiV1UserChangePasswordPost(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiV1UserChangePasswordPost(changePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Total Exp API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiV1UserExpsGet(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiV1UserExpsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User By Cookie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiV1UserGet(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiV1UserGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Nickname API
     * @param {number} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiV1UserNicknameGet(userId: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiV1UserNicknameGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch User By Cookie
     * @param {PatchUserRequest} patchUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiV1UserPatch(patchUserRequest: PatchUserRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiV1UserPatch(patchUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Profiles API
     * @param {GetUserProfilesRequest} getUserProfilesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiV1UserProfilesPost(getUserProfilesRequest: GetUserProfilesRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiV1UserProfilesPost(getUserProfilesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register User API
     * @param {RegisterUserRequest} registerUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiV1UserRegisterPost(registerUserRequest: RegisterUserRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiV1UserRegisterPost(registerUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new user type history.
     * @param {CreateUserTypeHistoryRequest} createUserTypeHistoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiV1UserTypePost(createUserTypeHistoryRequest: CreateUserTypeHistoryRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiV1UserTypePost(createUserTypeHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserPlanHistoriesApi - axios parameter creator
 * @export
 */
export const UserPlanHistoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update the status of a user plan history using token.
         * @param {UpdateUserPlanHistoryStatusRequest} updateUserPlanHistoryStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserPlanHistoriesPatch: async (updateUserPlanHistoryStatusRequest: UpdateUserPlanHistoryStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserPlanHistoryStatusRequest' is not null or undefined
            assertParamExists('apiV1UserPlanHistoriesPatch', 'updateUserPlanHistoryStatusRequest', updateUserPlanHistoryStatusRequest)
            const localVarPath = `/api/v1/user_plan_histories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserPlanHistoryStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new user plan history using token.
         * @param {CreateUserPlanHistoryRequest} createUserPlanHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserPlanHistoriesPost: async (createUserPlanHistoryRequest: CreateUserPlanHistoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserPlanHistoryRequest' is not null or undefined
            assertParamExists('apiV1UserPlanHistoriesPost', 'createUserPlanHistoryRequest', createUserPlanHistoryRequest)
            const localVarPath = `/api/v1/user_plan_histories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserPlanHistoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserPlanHistoriesApi - functional programming interface
 * @export
 */
export const UserPlanHistoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserPlanHistoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update the status of a user plan history using token.
         * @param {UpdateUserPlanHistoryStatusRequest} updateUserPlanHistoryStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserPlanHistoriesPatch(updateUserPlanHistoryStatusRequest: UpdateUserPlanHistoryStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserPlanHistoryStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserPlanHistoriesPatch(updateUserPlanHistoryStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserPlanHistoriesApi.apiV1UserPlanHistoriesPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new user plan history using token.
         * @param {CreateUserPlanHistoryRequest} createUserPlanHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserPlanHistoriesPost(createUserPlanHistoryRequest: CreateUserPlanHistoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserPlanHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserPlanHistoriesPost(createUserPlanHistoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserPlanHistoriesApi.apiV1UserPlanHistoriesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserPlanHistoriesApi - factory interface
 * @export
 */
export const UserPlanHistoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserPlanHistoriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Update the status of a user plan history using token.
         * @param {UpdateUserPlanHistoryStatusRequest} updateUserPlanHistoryStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserPlanHistoriesPatch(updateUserPlanHistoryStatusRequest: UpdateUserPlanHistoryStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateUserPlanHistoryStatusResponse> {
            return localVarFp.apiV1UserPlanHistoriesPatch(updateUserPlanHistoryStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new user plan history using token.
         * @param {CreateUserPlanHistoryRequest} createUserPlanHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserPlanHistoriesPost(createUserPlanHistoryRequest: CreateUserPlanHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserPlanHistoryResponse> {
            return localVarFp.apiV1UserPlanHistoriesPost(createUserPlanHistoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserPlanHistoriesApi - object-oriented interface
 * @export
 * @class UserPlanHistoriesApi
 * @extends {BaseAPI}
 */
export class UserPlanHistoriesApi extends BaseAPI {
    /**
     * 
     * @summary Update the status of a user plan history using token.
     * @param {UpdateUserPlanHistoryStatusRequest} updateUserPlanHistoryStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPlanHistoriesApi
     */
    public apiV1UserPlanHistoriesPatch(updateUserPlanHistoryStatusRequest: UpdateUserPlanHistoryStatusRequest, options?: RawAxiosRequestConfig) {
        return UserPlanHistoriesApiFp(this.configuration).apiV1UserPlanHistoriesPatch(updateUserPlanHistoryStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new user plan history using token.
     * @param {CreateUserPlanHistoryRequest} createUserPlanHistoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPlanHistoriesApi
     */
    public apiV1UserPlanHistoriesPost(createUserPlanHistoryRequest: CreateUserPlanHistoryRequest, options?: RawAxiosRequestConfig) {
        return UserPlanHistoriesApiFp(this.configuration).apiV1UserPlanHistoriesPost(createUserPlanHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserRewardApi - axios parameter creator
 * @export
 */
export const UserRewardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns: GetUserRewardsResponse: ユーザーのリワード情報
         * @summary [GET] 指定された user_id の全てのリワードコードと is_acquired を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRewardsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user_rewards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [PATCH] 指定されたリワードの is_acquired を False から True に更新する API
         * @param {UpdateAcquiredStatusRequest} updateAcquiredStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRewardsPatch: async (updateAcquiredStatusRequest: UpdateAcquiredStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAcquiredStatusRequest' is not null or undefined
            assertParamExists('apiV1UserRewardsPatch', 'updateAcquiredStatusRequest', updateAcquiredStatusRequest)
            const localVarPath = `/api/v1/user_rewards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAcquiredStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * JSON ペイロード:     - reward_code: 追加するリワードのコード  Returns:     PostUserRewardsResponse: 追加されたリワード情報
         * @summary [POST] 指定された user_id に対して user_rewards を作成する API
         * @param {PostUserRewardsRequest} postUserRewardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRewardsPost: async (postUserRewardsRequest: PostUserRewardsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postUserRewardsRequest' is not null or undefined
            assertParamExists('apiV1UserRewardsPost', 'postUserRewardsRequest', postUserRewardsRequest)
            const localVarPath = `/api/v1/user_rewards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postUserRewardsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserRewardApi - functional programming interface
 * @export
 */
export const UserRewardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserRewardApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns: GetUserRewardsResponse: ユーザーのリワード情報
         * @summary [GET] 指定された user_id の全てのリワードコードと is_acquired を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserRewardsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserRewardsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserRewardsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRewardApi.apiV1UserRewardsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [PATCH] 指定されたリワードの is_acquired を False から True に更新する API
         * @param {UpdateAcquiredStatusRequest} updateAcquiredStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserRewardsPatch(updateAcquiredStatusRequest: UpdateAcquiredStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAcquiredStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserRewardsPatch(updateAcquiredStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRewardApi.apiV1UserRewardsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * JSON ペイロード:     - reward_code: 追加するリワードのコード  Returns:     PostUserRewardsResponse: 追加されたリワード情報
         * @summary [POST] 指定された user_id に対して user_rewards を作成する API
         * @param {PostUserRewardsRequest} postUserRewardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserRewardsPost(postUserRewardsRequest: PostUserRewardsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostUserRewardsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserRewardsPost(postUserRewardsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRewardApi.apiV1UserRewardsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserRewardApi - factory interface
 * @export
 */
export const UserRewardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserRewardApiFp(configuration)
    return {
        /**
         * Returns: GetUserRewardsResponse: ユーザーのリワード情報
         * @summary [GET] 指定された user_id の全てのリワードコードと is_acquired を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRewardsGet(options?: RawAxiosRequestConfig): AxiosPromise<GetUserRewardsResponse> {
            return localVarFp.apiV1UserRewardsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [PATCH] 指定されたリワードの is_acquired を False から True に更新する API
         * @param {UpdateAcquiredStatusRequest} updateAcquiredStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRewardsPatch(updateAcquiredStatusRequest: UpdateAcquiredStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateAcquiredStatusResponse> {
            return localVarFp.apiV1UserRewardsPatch(updateAcquiredStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * JSON ペイロード:     - reward_code: 追加するリワードのコード  Returns:     PostUserRewardsResponse: 追加されたリワード情報
         * @summary [POST] 指定された user_id に対して user_rewards を作成する API
         * @param {PostUserRewardsRequest} postUserRewardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRewardsPost(postUserRewardsRequest: PostUserRewardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostUserRewardsResponse> {
            return localVarFp.apiV1UserRewardsPost(postUserRewardsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserRewardApi - object-oriented interface
 * @export
 * @class UserRewardApi
 * @extends {BaseAPI}
 */
export class UserRewardApi extends BaseAPI {
    /**
     * Returns: GetUserRewardsResponse: ユーザーのリワード情報
     * @summary [GET] 指定された user_id の全てのリワードコードと is_acquired を取得する API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRewardApi
     */
    public apiV1UserRewardsGet(options?: RawAxiosRequestConfig) {
        return UserRewardApiFp(this.configuration).apiV1UserRewardsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [PATCH] 指定されたリワードの is_acquired を False から True に更新する API
     * @param {UpdateAcquiredStatusRequest} updateAcquiredStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRewardApi
     */
    public apiV1UserRewardsPatch(updateAcquiredStatusRequest: UpdateAcquiredStatusRequest, options?: RawAxiosRequestConfig) {
        return UserRewardApiFp(this.configuration).apiV1UserRewardsPatch(updateAcquiredStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * JSON ペイロード:     - reward_code: 追加するリワードのコード  Returns:     PostUserRewardsResponse: 追加されたリワード情報
     * @summary [POST] 指定された user_id に対して user_rewards を作成する API
     * @param {PostUserRewardsRequest} postUserRewardsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRewardApi
     */
    public apiV1UserRewardsPost(postUserRewardsRequest: PostUserRewardsRequest, options?: RawAxiosRequestConfig) {
        return UserRewardApiFp(this.configuration).apiV1UserRewardsPost(postUserRewardsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserSettingsApi - axios parameter creator
 * @export
 */
export const UserSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns: UserSettingResponse: ユーザー設定情報
         * @summary 現在のユーザー設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserSettingsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user_settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * JSON ペイロード:     - study_course_id: 学習コースID  Returns:     UserSettingResponse: 更新されたユーザー設定情報
         * @summary ユーザー設定を更新する（存在しない場合は作成）
         * @param {UserSettingUpdateRequest} userSettingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserSettingsPatch: async (userSettingUpdateRequest: UserSettingUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userSettingUpdateRequest' is not null or undefined
            assertParamExists('apiV1UserSettingsPatch', 'userSettingUpdateRequest', userSettingUpdateRequest)
            const localVarPath = `/api/v1/user_settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSettingUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserSettingsApi - functional programming interface
 * @export
 */
export const UserSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns: UserSettingResponse: ユーザー設定情報
         * @summary 現在のユーザー設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserSettingsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserSettingsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSettingsApi.apiV1UserSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * JSON ペイロード:     - study_course_id: 学習コースID  Returns:     UserSettingResponse: 更新されたユーザー設定情報
         * @summary ユーザー設定を更新する（存在しない場合は作成）
         * @param {UserSettingUpdateRequest} userSettingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserSettingsPatch(userSettingUpdateRequest: UserSettingUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserSettingsPatch(userSettingUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSettingsApi.apiV1UserSettingsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserSettingsApi - factory interface
 * @export
 */
export const UserSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserSettingsApiFp(configuration)
    return {
        /**
         * Returns: UserSettingResponse: ユーザー設定情報
         * @summary 現在のユーザー設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserSettingsGet(options?: RawAxiosRequestConfig): AxiosPromise<UserSettingResponse> {
            return localVarFp.apiV1UserSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * JSON ペイロード:     - study_course_id: 学習コースID  Returns:     UserSettingResponse: 更新されたユーザー設定情報
         * @summary ユーザー設定を更新する（存在しない場合は作成）
         * @param {UserSettingUpdateRequest} userSettingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserSettingsPatch(userSettingUpdateRequest: UserSettingUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingResponse> {
            return localVarFp.apiV1UserSettingsPatch(userSettingUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserSettingsApi - object-oriented interface
 * @export
 * @class UserSettingsApi
 * @extends {BaseAPI}
 */
export class UserSettingsApi extends BaseAPI {
    /**
     * Returns: UserSettingResponse: ユーザー設定情報
     * @summary 現在のユーザー設定を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApi
     */
    public apiV1UserSettingsGet(options?: RawAxiosRequestConfig) {
        return UserSettingsApiFp(this.configuration).apiV1UserSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * JSON ペイロード:     - study_course_id: 学習コースID  Returns:     UserSettingResponse: 更新されたユーザー設定情報
     * @summary ユーザー設定を更新する（存在しない場合は作成）
     * @param {UserSettingUpdateRequest} userSettingUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApi
     */
    public apiV1UserSettingsPatch(userSettingUpdateRequest: UserSettingUpdateRequest, options?: RawAxiosRequestConfig) {
        return UserSettingsApiFp(this.configuration).apiV1UserSettingsPatch(userSettingUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserStampApi - axios parameter creator
 * @export
 */
export const UserStampApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns: GetUserStampsResponse: ユーザーのスタンプ情報
         * @summary [GET] 指定された user_id の全てのスタンプを取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserStampsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user_stamps/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [PATCH] 指定されたUser Stamp IDの is_checked を False から True に更新する API
         * @param {UpdateCheckedStatusRequest} updateCheckedStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserStampsPatch: async (updateCheckedStatusRequest: UpdateCheckedStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCheckedStatusRequest' is not null or undefined
            assertParamExists('apiV1UserStampsPatch', 'updateCheckedStatusRequest', updateCheckedStatusRequest)
            const localVarPath = `/api/v1/user_stamps/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCheckedStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * JSON ペイロード:     - stamp_id: 追加するスタンプの ID     - message: 追加するメッセージ  Returns:     PostUserStampsResponse: 追加されたユーザースタンプ情報
         * @summary [POST] 指定された user_id に対して user_stamps を作成する API
         * @param {PostUserStampsRequest} postUserStampsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserStampsPost: async (postUserStampsRequest: PostUserStampsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postUserStampsRequest' is not null or undefined
            assertParamExists('apiV1UserStampsPost', 'postUserStampsRequest', postUserStampsRequest)
            const localVarPath = `/api/v1/user_stamps/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Application-Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-Application-Token", configuration)

            // authentication Cookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postUserStampsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserStampApi - functional programming interface
 * @export
 */
export const UserStampApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserStampApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns: GetUserStampsResponse: ユーザーのスタンプ情報
         * @summary [GET] 指定された user_id の全てのスタンプを取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserStampsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserStampsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserStampsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserStampApi.apiV1UserStampsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [PATCH] 指定されたUser Stamp IDの is_checked を False から True に更新する API
         * @param {UpdateCheckedStatusRequest} updateCheckedStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserStampsPatch(updateCheckedStatusRequest: UpdateCheckedStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCheckedStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserStampsPatch(updateCheckedStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserStampApi.apiV1UserStampsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * JSON ペイロード:     - stamp_id: 追加するスタンプの ID     - message: 追加するメッセージ  Returns:     PostUserStampsResponse: 追加されたユーザースタンプ情報
         * @summary [POST] 指定された user_id に対して user_stamps を作成する API
         * @param {PostUserStampsRequest} postUserStampsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserStampsPost(postUserStampsRequest: PostUserStampsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostUserStampsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserStampsPost(postUserStampsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserStampApi.apiV1UserStampsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserStampApi - factory interface
 * @export
 */
export const UserStampApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserStampApiFp(configuration)
    return {
        /**
         * Returns: GetUserStampsResponse: ユーザーのスタンプ情報
         * @summary [GET] 指定された user_id の全てのスタンプを取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserStampsGet(options?: RawAxiosRequestConfig): AxiosPromise<GetUserStampsResponse> {
            return localVarFp.apiV1UserStampsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [PATCH] 指定されたUser Stamp IDの is_checked を False から True に更新する API
         * @param {UpdateCheckedStatusRequest} updateCheckedStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserStampsPatch(updateCheckedStatusRequest: UpdateCheckedStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCheckedStatusResponse> {
            return localVarFp.apiV1UserStampsPatch(updateCheckedStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * JSON ペイロード:     - stamp_id: 追加するスタンプの ID     - message: 追加するメッセージ  Returns:     PostUserStampsResponse: 追加されたユーザースタンプ情報
         * @summary [POST] 指定された user_id に対して user_stamps を作成する API
         * @param {PostUserStampsRequest} postUserStampsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserStampsPost(postUserStampsRequest: PostUserStampsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostUserStampsResponse> {
            return localVarFp.apiV1UserStampsPost(postUserStampsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserStampApi - object-oriented interface
 * @export
 * @class UserStampApi
 * @extends {BaseAPI}
 */
export class UserStampApi extends BaseAPI {
    /**
     * Returns: GetUserStampsResponse: ユーザーのスタンプ情報
     * @summary [GET] 指定された user_id の全てのスタンプを取得する API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserStampApi
     */
    public apiV1UserStampsGet(options?: RawAxiosRequestConfig) {
        return UserStampApiFp(this.configuration).apiV1UserStampsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [PATCH] 指定されたUser Stamp IDの is_checked を False から True に更新する API
     * @param {UpdateCheckedStatusRequest} updateCheckedStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserStampApi
     */
    public apiV1UserStampsPatch(updateCheckedStatusRequest: UpdateCheckedStatusRequest, options?: RawAxiosRequestConfig) {
        return UserStampApiFp(this.configuration).apiV1UserStampsPatch(updateCheckedStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * JSON ペイロード:     - stamp_id: 追加するスタンプの ID     - message: 追加するメッセージ  Returns:     PostUserStampsResponse: 追加されたユーザースタンプ情報
     * @summary [POST] 指定された user_id に対して user_stamps を作成する API
     * @param {PostUserStampsRequest} postUserStampsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserStampApi
     */
    public apiV1UserStampsPost(postUserStampsRequest: PostUserStampsRequest, options?: RawAxiosRequestConfig) {
        return UserStampApiFp(this.configuration).apiV1UserStampsPost(postUserStampsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



